import _ from 'lodash'
import axios from 'axios'
import base64url from 'base64url'
// const Buffer = require('buffer/').Buffer
import cbor from 'cbor-js'
import * as Comlink from 'comlink'
import { Array } from 'core-js'
import diff from 'deep-diff'
const Hashes = require('jshashes')
import hex2ab from 'hex-to-array-buffer'
import QuickEncrypt from 'quick-encrypt'
import QR from 'qrcode'
import qs from 'qs'
import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex)


import st from './state'
import mu from './mutations'
import ut from './util'
const [t, f] = [true, false];
const { fb, fbBase, fbBaseConfig, fbusersbase, fbBaseUsers, fbBaseLex, fbBaseState, fbBaseTokens, storage } = ut.fb()
var version = '1'


export const act = {
  // API
  async api(state, payload) {
    console.log('api', { payload });
    // payload = {address, verb, config, data}
    if (payload.hook) {
      payload.hook.from = 'api_' + payload.address
      store.dispatch('run', payload.hook)
      // TODO encapsulate execution context to hook generator function. yield => next
    }
    if (!payload.verb) payload.verb = 'get';
    var timeStart = Date.now()
    // console.log(payload.address, payload.data || {}, payload.config || {});

    // let passdata = !payload.data && payload.verb == 'get' ? [payload.address, payload.config] : [payload.address, payload.data || {}, payload.config || {}]
    // console.log({ passdata });

    if (!payload.config) payload.config = {}
    let options = {
      method: payload.verb || 'get',
      url: payload.address,
      ...payload.config
    }
    payload.data ? options.data = options.url.includes('xmba-cloud-api') ? qs.stringify(payload.data) : payload.data : null

    // return await axios[payload.verb || 'get'](...passdata)
    return await axios(options).then((ret) => {
      console.log('api return', ret);
      mu.log('api time', Date.now() - timeStart, payload)
      return ret
    }).catch((err) => {
      return err
    })
  },
  async auth({ commit, state }, payload) {
    if (store.state.debug) mu.log('auth', payload)
    if (payload.type === 'token') {
      fb.auth().signInWithCustomToken(payload.token).then(d => {
        window.localStorage.setItem('auth', JSON.stringify(d.user))
        return commit('setState', { prop: 'auth', val: d.user })
      })
    }
    else if (payload.type === 'signinwithemaillink') {
      if (fb.auth().isSignInWithEmailLink(window.location.href)) {
        var email = window.localStorage.getItem("emailForSignIn") || window.prompt("Please provide your email for confirmation");
        fb.auth()
          .signInWithEmailLink(email, window.location.href)
          .then((result) => {
            console.log("resulting user after magic button ", result.user);
            mu.setState(store.state, {
              prop: "auth",
              val: result.user,
            });
            window.localStorage.setItem("auth", JSON.stringify(result.user));
            act.auth(store.state, {
              type: "usercheck",
              email,
            })
              .then(() => {
                act.auth(store.state, {
                  type: "completesignup",
                  url: window.location.href,

                  email,
                })
                window.localStorage.removeItem("emailForSignIn");
                // this.$route.replace({path: '/'})
                window.location.href = window.location.origin;
              });
          })
          .catch(function (error) {
            console.log(error);
          });

      }

    }
    else if (payload.type === 'email') {
      fb.auth().signInWithEmailAndPassword(payload.email, payload.password).then((data) => {
        if (data.user) {
          let globaluserdata = JSON.parse(JSON.stringify(data.user))
          fbBase.collection('user').doc(data.user.uid)
            .get().then((userData) => {
              var wb = fb.firestore().batch()
              if (userData.exists) {
                var updateData = userData.data()

                updateData.signin = updateData.signin || []
                updateData.signin.push(Date.now())
                wb.set(fbusersbase.collection(data.user.uid).doc('auth'), globaluserdata, { merge: t })
                wb.set(fbBaseUsers, { [data.user.uid]: globaluserdata }, { merge: t })
                wb.set(fbusersbase.collection(data.user.uid).doc('apps'), { [store.state.app.basics.database]: t }, { merge: t })
                wb.set(fbBase.collection('user').doc(data.user.uid), updateData, { merge: t })
                  // .set(fbBase.collection('user').doc(data.user.uid).collection('private').doc('content'), privateData)
                  .commit().then(() => {
                    window.localStorage.setItem('auth', JSON.stringify(data.user))
                    window.localStorage.setItem('email', payload.email)
                    return window.location.reload()
                  })
              } else {
                var indexObj = {}
                var timestamp = Date.now()
                indexObj[data.user.uid] = timestamp
                var userContent = {
                  uid: data.user.uid,
                  id: data.user.uid,
                  name: 'Glootie',
                  purpose: ''
                }
                // var privateData = {
                //   email: data.user.email,
                //   signin: [Date.now()]
                // }
                // let globaluserdata = JSON.parse(JSON.stringify(data.user))
                wb.set(fbusersbase.collection(data.user.uid).doc('auth'), globaluserdata, { merge: t })
                wb.set(fbusersbase.collection(data.user.uid).doc('apps'), { [store.state.app.basics.database]: t }, { merge: t })
                wb.set(fbBase.collection('user').doc(data.user.uid), userContent, { merge: t })
                  .commit().then(() => {
                    Vue.set(store.state, 'auth', data.user)
                    window.localStorage.setItem('auth', JSON.stringify(data.user))
                    window.localStorage.setItem('email', payload.email)
                    return window.location.reload()
                  })
              }
            })
        }
      }).catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message
        // [START_EXCLUDE]
        if (errorCode === 'auth/wrong-password') {
          alert('Wrong password.')
        } else {
          alert(errorMessage)
        }
        console.log(error)
        document.getElementById('quickstart-sign-in').disabled = f
        // [END_EXCLUDE]
      })
    } else if (payload.type === 'social') {
      var provider = payload.provider === 'facebook' ? new fb.auth.FacebookAuthProvider() : payload.provider === 'google' ? new fb.auth.GoogleAuthProvider() : console.error('Nothing to provide')
      fb.auth().signInWithPopup(provider).then(async (result) => {
        var user = JSON.parse(JSON.stringify(result.user))
        var userContent = {
          uid: user.uid,
          id: user.uid,
          name: user.displayName,
          provider: payload.provider
        }
        var privateData = {
          email: user.email,
          signin: [Date.now()]
        }
        var wb = fb.firestore().batch()
        wb.set(fbusersbase.collection(user.uid).doc('auth'), user, { merge: t })
        wb.set(fbBaseUsers, { [user.uid]: userContent }, { merge: t })
        wb.set(fbusersbase.collection(user.uid).doc('apps'), { [store.state.app.basics.database]: t }, { merge: t })
        wb.set(fbBase.collection('user').doc(user.uid), userContent, { merge: t })
        wb.set(fbBase.collection('user').doc(user.uid).collection('private').doc('content'), privateData, { merge: t })
        return wb.commit().then(() => {
          window.localStorage.setItem('auth', JSON.stringify(userContent))
          window.localStorage.setItem('email', user.email)
          mu.set(store.state, { key: 'auth', val: userContent })
          mu.set(store.state, { keys: ['componentKeys', 'auth'], val: user.uid })
          return window.location.reload()
        })
      }).catch(function (error) {
        var errorCode = error.code
        var errorMessage = error.message
        var email = error.email
        var credential = error.credential
        console.log(errorCode, errorMessage, email, credential)
      })
    } else if (payload.type === 'create') {
      // TODO generate private key and use public key to encrypt private token data. Check for past users, i.e. b4 tokenizationing

      return fb.auth().createUserWithEmailAndPassword(payload.email, payload.password).then(async (data) => {
        let globaluserdata = JSON.parse(JSON.stringify(data.user))
        payload.type = 'email'
        const id = data.user.uid
        var userContent = {
          uid: id,
          id: id,
          name: 'Anon ' + Date.now(),
          purpose: 'Undefined',
          required: payload.requirements,
        }
        var privateData = {
          email: data.user.email,
          signin: [Date.now()]
        }
        var wb = fb.firestore().batch()
        wb.set(fbusersbase.collection(id).doc('auth'), globaluserdata, { merge: t })
        wb.set(fbusersbase.collection(data.user.uid).doc('apps'), { [store.state.app.basics.database]: t }, { merge: t })
        wb.set(fbBase.collection('user').doc(id), userContent)
        wb.set(fbBase.collection('user').doc(id).collection('private').doc('content'), privateData)
        wb.commit()
        act.auth(state, payload)
        return [userContent, privateData]
      }).catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message
        console.error(errorCode, errorMessage)
      })
    } else if (payload.type === 'reset') {
      var resetCodeSettings = {
        url: window.location.origin + '/?email=' + payload.email,
        handleCodeInApp: t
      }
      fb.auth().sendPasswordResetEmail(
        payload.email, resetCodeSettings)
        .then(function () {
          console.alert('Password reset sent to email.')
        })
        .catch(function (error) {
          console.log(error)
        })
    } else if (payload.type === 'magiclink') {
      var actionCodeSettings = {
        url: window.location.origin,
        handleCodeInApp: t
      }
      fb.auth().sendSignInLinkToEmail(payload.email, actionCodeSettings).then(function () {
        localStorage.setItem('emailForSignIn', payload.email)
      }).catch(function (error) {
        console.error(error)
      })
    } else if (payload.type === 'completesignup') {
      if (store.state.userExists) {
        alert('User exists. Reset password instead.');
      } else {
        var pass = prompt('Cheers. Please choose a password.')
        var newPass = prompt('Once more...')
        if (newPass !== pass) {
          act.auth(state, payload)
        } else {
          act.auth(state, { type: 'changepass', pass })
        }
      }
    } else if (payload.type === 'changepass') {
      var user = fb.auth().currentuser
      user.updatePassword(payload.pass)
    } else if (payload.type === 'logout') {
      fb.auth().signOut()
      state.auth = {}
      localStorage.clear()
      if (caches) {
        caches.keys().then((keys) => {
          if (keys.length > 0) {
            keys.forEach((key, keyIndex) => {
              caches.delete(key)
              if (keyIndex === keys.length - 1) {
                window.location.reload()
              }
            })
          } else {
            window.location.reload()
          }
        })
      } else {
        window.location.reload()
      }
    } else if (payload.type === 'usercheck') {
      if (!payload.email) return f
      store.state.isEmail = t
      return fb.auth().fetchSignInMethodsForEmail(payload.email).then(function (result) {
        if (result[0]) {
          store.state.userExists = t
        } else {
          return f
        }
        return store.state.userExists
      })
    } else if (payload.type === 'currentuser') {
      var currentuser = fb.auth().currentUser
      if (store.state.user[currentuser.uid] || store.state.users[currentuser.uid]) {
        return currentuser.uid
      } else {
        return currentuser.uid ? fbBase.collection('user').doc(currentuser.uid).get().then((userData) => {
          return userData.exists ? currentuser.uid : act.auth(st, { type: 'logout' })
        }) : f
      }
    } else {
      alert('Incomplete authorization')
      return console.error('Incomplete authorization', payload)
    }
  },
  async blockfrostipfs(state, payload) {
    // payload = {file, client}
    mp('Pinning to IPFS', file)
    let client, file = payload.file
    if (!payload.client) {
      client = 'agapeipfs3' // todo let clients set and select their own keys
    } else { client = payload.client }
    console.log({ file });
    const ipfs = store.dispatch('api', {
      address: store.state.cloudurl + `ipfs?client=${client}&url=${encodeURI(file.url[0])}&name=${file.name}&mime=${file.type}&xmbltoken=${file.token[1]}&hash=${file.hash}`
    })
    return await ipfs.then(x => {
      file.ipfs = x.data && x.data.pinned.ipfs_hash
      mp('Pinned to IPFS', file.ipfs, t)
      d('update', {
        type: 'files',
        hash: file.hash,
        data: file,
      })
    })
  },
  async create(state, payload) {
    console.log('creating from payload', payload);
    if (!store.state.auth.uid) {
      return store.state.show.auth = t
    } else if (payload.data && !payload.data.ownedBy) {
      payload.data.ownedBy = store.state.auth.uid
    }
    if (store.state.debug) mu.log('create', payload)
    // creates a database entry payload === {ref:'string', document:'id-string', data: {}}
    if (payload.type === 'app') {
      payload.data.user = [store.state.auth.uid]
      payload.data.owner = store.state.auth.uid
      payload.data.style = store.state.app.style
      payload.data.basics.database = location.hostname
      return fb.firestore().collection(encodeURIComponent(payload.data.basics.database)).doc('v' + version).set({
        app: payload.data
      }, { merge: t }).then(() => {
        fb.firestore().collection('apps').doc('v' + version).set({
          [encodeURIComponent(payload.data.basics.database)]: t
        }, { merge: t })
        mu.setStyle(store.state);
        return window.location.href = 'https://' + payload.data.basics.database
      })
    } else if (payload.type === 'fromdata') {
      let name = payload.data.name, model = payload.data.model
      let workingmodel = act.validjson(state, model) ? JSON.parse(model) : model,
        list = [],
        determineinputtype = (example) => {
          if (
            (typeof example == "string" && act.validjson(state, example)) ||
            (typeof example == "object" && !Array.isArray(example))
          ) {
            return ["form", t];
          }

          if (
            (typeof example == "string" && act.validjson(state, example)) ||
            (typeof example == "object" && Array.isArray(example))
          ) {
            return ["select", t];
          }

          if (
            typeof example == "string" &&
            !act.validjson(state, example) &&
            isNaN(example)
          ) {
            return ["input", "text"];
          }

          if (typeof example === "number" || !isNaN(example)) {
            return ["input", "number"];
          }

          if (typeof example === "boolean") {
            return ["check", "true"];
          }
        };
      if (Array.isArray(workingmodel)) {
        list = JSON.parse(JSON.stringify(workingmodel));
        workingmodel = list[0];
      }
      if (store.state.app.itemTypes.indexOf(name) > -1) {
        list.length > 0 &&
          act.create(state, {
            type: name,
            data: list,
            multiple: t,
          });
      } else {
        let item = {
          comments: f,
          crowdallowed: f,
          forms: [
            {
              name: "basics",
              description: "The basic bits of an item.",
              inputs: [
                {
                  inputType: "input",
                  label: "title",
                  type: "text",
                  placeholder: "title",
                  default: "",
                  priority: 1,
                },
                {
                  inputType: "textarea",
                  label: "description",
                  type: "text",
                  placeholder: "Description",
                  default: "",
                  priority: 2,
                },
                {
                  inputType: "file",
                  label: "image",
                  type: "image",
                  placeholder: "Image Url",
                  default: "",
                  priority: 3,
                },
                {
                  inputType: "tags",
                  label: "tags",
                  type: "tags",
                  placeholder: "tags",
                  default: [],
                  priority: 4,
                },
              ],
            },
            {
              description: "",
              inputs: [],
              name: "info",
            },
          ],
          name: name,
          reputation: f,
          type: "asset",
        };
        item.forms[1].inputs = Object.entries(workingmodel).map((x) => {
          return {
            default: "",
            label: x[0],
            inputType: determineinputtype(x[1])[0],
            placeholder: x[0],
            type: determineinputtype(x[1])[1],
            if: []
          };
        });
        store.state.app.basics.items.push(item);
        store.state.app.itemTypes.push(name);
        store.state.app.itemTypes = [
          ...new Set(store.state.app.itemTypes),
        ];
        act.update(state, { type: "app", data: store.state.app })
          .then(() => {
            list.length > 0 &&
              act.create(state, {
                type: name,
                data: list,
                multiple: t,
              });
          });
      }
    }
    else if (payload.type === 'msg') {
      payload.data.id = fbBase.collection('msgs').doc().id
      payload.data.topic = payload.data.topic || 'Set topic?'
      payload.data.owner = store.state.auth.uid
      const msgBatch = fb.firestore().batch()
      msgBatch.set(fbBase.collection('msgs').doc(payload.data.id), payload.data, { merge: t }).commit().then(() => {
        payload.data.users.forEach((user) => {
          var docRef = fbBase.collection('user').doc(user)
          docRef.get().then((userData) => {
            var user = userData.data()
            user.msgs = user.msgs || {}
            if (user === store.state.auth.uid) {
              user.msgs[payload.data.id] = t
            } else {
              user.msgs[payload.data.id] = 'unseen'
            }
            fb.firestore().batch().set(docRef, user, { merge: t }).commit().then(() => {
              act.query(state, { type: 'msgs' })
            })
          })
        })
      })
      return payload.data.id
    } else if (payload.type === 'notification') {
      payload.data.id = fbBase.collection('notifications').doc().id
      payload.data.timestamp = Date.now()
      const notifyBatch = fb.firestore().batch()
      payload.data.actions = payload.data.actions || []
      payload.data.subMessage = payload.data.subMessage || ''
      return notifyBatch.set(fbBase.collection('notifications').doc(payload.data.id), payload.data, { merge: t }).commit().then(() => {
        payload.data.to.forEach((user) => {
          var docRef = fbBase.collection('user').doc(user)
          docRef.get().then((userData) => {
            var user = userData.data()
            user.notifications = user.notifications || {}
            // user.notifications[payload.data.id] = t
            Vue.set(user.notifications, payload.data.id, t)
            fb.firestore().batch().update(docRef, user).commit()
          })
        })
      })
    } else if (payload.type === 'comments') {
      payload.comment.id = fbBase.collection('comments').doc().id
      payload.comment.ownedBy = store.state.auth.uid
      const comment = {
        [payload.comment.id]: payload.comment
      }
      const commentBatch = fb.firestore().batch()
      return commentBatch.set(fbBase.collection('comments').doc(payload.id), comment, { merge: t }).commit().then(() => {
        act.query(state, { type: 'comments', id: payload.id })
        return 'Comment posted'
      })
    } else if (payload.type === 'reputation') {
      var newId = fbBase.collection('reputation').doc().id
      const reputation = {
        [newId]: {
          ref: payload.id,
          feedback: payload.data,
          user: store.state.auth.uid,
          timestamp: Date.now(),
          type: 'reputation',
          rId: newId,
          rType: payload.data.type || payload.fType || 'Untyped'
        }
      }
      // TODO set user activity on user something
      const reputationBatch = fb.firestore().batch()
      return reputationBatch.set(fbBase.collection('reputation').doc(payload.id), reputation, { merge: t }).commit().then(async () => {
        if (typeof store.state.user[store.state.auth.uid].userreps !== 'object' || Array.isArray(store.state.user[store.state.auth.uid].userreps)) { store.state.user[store.state.auth.uid].userreps = {} }
        console.log(store.state.user[store.state.auth.uid].userreps);
        store.commit('set', { keys: ['user', store.state.auth.uid, 'userreps', payload.id], val: newId })
        store.dispatch('update', { type: 'user', data: store.state.user[store.state.auth.uid] })

        var tRef = fbBase.collection('reputation').doc(payload.id).collection('meta').doc('stats')
        console.log('error b4', tRef);
        return fb.firestore().runTransaction(function (t) {
          return t.get(tRef).then(function (sfDoc) {
            if (!sfDoc.exists) {
              return t.set(tRef, { count: 1, quality: payload.data.quality }, { merge: t })
            }
            var newCount = sfDoc.data().count + 1
            var totalQuality = Number(sfDoc.data().quality) + Number(payload.data.quality)
            console.log('searching to find error', { tRef, sfDoc: sfDoc, payloaddata: payload.data });
            return t.set(tRef, { count: newCount, quality: totalQuality }, { merge: f })
          })
        }).then(function () {
          act.query(state, { type: 'reputation', id: payload.id })
          return reputation
        }).catch(function (error) {
          console.log('Transaction failed: ', error)
        })
      })
    } else if (payload.type === 'order') {
      var cart = payload.cart || store.state.user[store.state.auth.uid].cart
      var orderDate = Date.now()
      var shipping = payload.data['Shipping']
      var payment = payload.data['Payment']
      var orderId = fbBase.collection('orders').doc().id
      var sellers = {}
      var fullOrder = {
        id: orderId,
        complete: f,
        paid: f,
        shipping: shipping,
        items: [],
        total: 0,
        timestamp: orderDate
      }
      Object.keys(cart).forEach((order) => {
        if (cart) {
          var orderArr = cart[order]
          var orderObj = {
            type: orderArr[0],
            iitemid: orderArr[1],
            purchase: orderArr[2],
            qty: orderArr[3],
            seller: orderArr[4],
            itemTitle: orderArr[5],
            status: 'new-order', // ['new-order', 'processing', 'shipped', 'delivered', 'order-error']
            shipping: shipping,
            orderId,
            buyer: store.state.auth.uid || 'anon',
            timestamp: orderDate
          }
          var subTotal = (orderObj.qty * orderObj.purchase.cost) + (typeof orderObj.purchase['shipping and handling'] === 'number' ? orderObj.purchase['shipping and handling'] : 0)
          sellers[orderObj.seller] = sellers[orderObj.seller] || []
          sellers[orderObj.seller].push(orderObj)
          fullOrder.items.push(orderObj)
          fullOrder.total = +fullOrder.total + +subTotal
        }
      })

      const orderBatch = fb.firestore().batch()
      fullOrder.total = Number(fullOrder.total).toFixed(2)
      return orderBatch.set(fbBase.collection('orders').doc(orderId), fullOrder, { merge: t }).commit().then(() => {
        mu.log('order creation success', payment['payment-type'])
        act.transact(store.state, { orderId, payment, fullOrder })
        store.state.user[store.state.auth.uid].orders = store.state.user[store.state.auth.uid].orders || []
        store.state.user[store.state.auth.uid].orders.push(orderId)
        Vue.set(store.state.user[store.state.auth.uid], 'cart', {})
        Vue.set(store.state.counts, 'cart', 0)
        store.state.show.cart = f
        fb.firestore().batch().update(fbBase.collection('user').doc(store.state.auth.uid), store.state.user[store.state.auth.uid]).commit()
        Object.keys(sellers).forEach((seller) => {
          var docRef = fbBase.collection('user').doc(seller)
          docRef.get().then((userData) => {
            var user = userData.data()
            user.sales = user.sales || {}
            user.sales[orderId] = sellers[seller]
            fb.firestore().batch().set(docRef, user, { merge: t }).commit().then(() => {
              act.notify('sale', 'Order created', [sellers[seller][0].seller], store.state.auth.uid, `/sales/${sellers[seller][0].orderId}`, sellers[seller][0].orderId, `Order ID: ${sellers[seller][0].orderId}`, ['fulfill', 'send thank you and request pay'])
              act.notify('order', `Order ${sellers[seller][0].orderId} created`, [sellers[seller][0].buyer], 'transaction', `/orders/${sellers[seller][0].orderId}`, sellers[seller][0].orderId)
            })
          })
        })
        return fullOrder
      })
    } else if (payload.type === 'value') {
      let wb = fb.firestore().batch()
      console.log(payload)
      wb.set(fbusersbase.collection(st.auth.uid).doc('values'), { [store.state.app.basics.database]: { [payload.key]: payload.value } }, { merge: t })
      return wb.set(fbBase.collection('user').doc(st.auth.uid).collection(payload.type).doc(payload.datatype), { [payload.key]: payload.value }, { merge: t }).commit().then(() => {
        st.value[payload.datatype] = st.value[payload.datatype] || {}
        st.value[payload.datatype][payload.key] = st.value[payload.datatype][payload.key] || {}
        return mu.setState(st.value, { prop: payload.datatype, prop2: payload.key, val: payload.value })
        // return act.query(state, {type: payload.type, id: payload.id, itemType: payload.itemType})
      })
    } else {
      let itemconfig = store.state.app.basics.items.filter(
        (x) => x.name === payload.type
      )[0];
      if (itemconfig && itemconfig.hooks && itemconfig.hooks.create && (itemconfig.hooks.create.fun || itemconfig.hooks.create.get)) {
        let name = itemconfig.hooks.create.fun ? itemconfig.hooks.create.fun.name : itemconfig.hooks.create.get.name
        store.dispatch("run", {
          from: 'item create ' + payload.type,
          if: itemconfig.hooks.create.if || [],
          fun: store.state.app.advanced.functions[name],
          payload: itemconfig.hooks.create.getpayload || itemconfig.hooks.create.payload || {},
        });
      }
      var userRef = fbBase.collection('user').doc(st.auth.uid)
      var wb = fb.firestore().batch()
      let setdata = async (entry, user) => {
        console.log('setdata()', { entry, user });
        let wellformed = {}
        // Housekeeping 
        Object.keys(entry).forEach((key) => {
          if (!payload.data[key]) delete payload.data[key]
        })
        const date = Date.now()
        wellformed.created = date
        st.app.basics.items[st.app.itemTypes.indexOf(payload.type)].forms.map((section) => {
          wellformed[section.name] = {};
          section.inputs.map(x => (wellformed[section.name][x.label] = entry[section.name] && entry[section.name][x.label] ? entry[section.name][x.label] : entry[x.label] || ''))
        })
        wellformed.user = st.auth.uid
        wellformed.type = payload.type
        !wellformed.basics.title ? wellformed.basics.title = entry.title || entry.name || entry.id || wellformed.created : null
        const hashes = await store.dispatch('t', { type: store.state.lexicon.create.item, payload: wellformed }).then(h => h)
        console.log('hashes', hashes);
        var document = fbBase.collection(payload.type).doc(hashes[1] || '')
        console.log('create document', document);
        user.items[payload.type].push(document.id)
        user.items[payload.type] = [...new Set(user.items[payload.type])]
        store.dispatch('indexer', [wellformed, document.id, payload.type])
        mu.point(store.state, {
          header: payload.type + ' created',
          text: document.id,
          link: '/i/' + payload.type + '/' + document.id,
          sticky: f,
          speed: 0
        })
        wellformed.hash = hashes[0]
        wellformed.id = document.id
        wb.set(document, wellformed)
        return document
      }

      return userRef.get().then(async (userData) => {
        var updateObj = userData.data()
        if (!updateObj.items) { updateObj.items = {} }
        if (!updateObj.items[payload.type]) {
          updateObj.items[payload.type] = []
        } else if (updateObj.items[payload.type] && !Array.isArray(updateObj.items[payload.type])) {
          var newArr = []
          Object.keys(updateObj.items[payload.type]).forEach((objKey) => {
            newArr.push(objKey)
          })
          updateObj.items[payload.type] = newArr
        } else {
          console.log('Unknown entry', payload)
        }

        // Checks for an array of items to map and set, else sets item
        console.log(updateObj);
        payload.multiple ? payload.data.map(async entry => {
          await setdata(entry, updateObj).then(d => d)
        }) : await setdata(payload.data, updateObj).then(d => d)

        wb.set(fbusersbase.collection(store.state.auth.uid).doc('assets'), { [store.state.app.basics.database]: updateObj }, { merge: t })
        wb.set(fbBase.collection('user').doc(store.state.auth.uid), updateObj, { merge: t }).commit()
        payload.data.secret && Vue.set(st, 'secretCode', payload.data.id)
        payload.data.secret && setTimeout(() => {
          Vue.set(st, 'secretCode', '')
        }, 10000)
        // mu.closeAll(store.state)
        return payload.data
      })
    }
  },
  async crypto(state, payload) {
    const c = {
      address: async () => { // payload.data = {chain, passhash, key} 
        return store.dispatch('api', {
          address: store.state.cloudurl + 'getaddress',
          verb: 'post',
          data: payload.data
        })
      },
      asset: async () => { },
      mint: async () => {
        let tx = payload.data.tx, key = payload.data.key, inputs = payload.data.inputs
        let metadata = {}
        let mint = function (tx) {
          console.log({ minting: tx })
          mp('minting', payload.data, t)
          let developing = f
          if (developing) {
            return { tx }
          }
          return store
            .dispatch("api", {
              address: store.state.cloudurl + "minttokens",
              verb: "post",
              data: tx,
            })
            .then((x) => {
              console.log({ x });
              return x
            })
            .catch((e) => console.log({ e }));
        }

        tx.address = inputs.selectaddress[key].address;
        tx.chain = inputs.selectaddress[key].chain;
        tx.verification = key;
        tx.passhash = inputs.newtx[key].passhash;
        tx.submit = "True";
        m("point", {
          header: "Minting",
          text: `Minting ${JSON.stringify(tx)} from ${inputs.selectaddress[key].address
            }`,
          type: "update",
          sticky: true
        });
        tx.inputs = [];
        console.log({ minting_tx: tx });
        // TODO encrypt with cloud public key
        if (tx.meta.fileids) {
          m('point', { 'header': 'Minting', 'text': 'Processing Files' })
          metadata.files = tx.meta.fileids.map(x => store.state.user[store.state.auth.uid].files[x])
          metadata.files = metadata.files.map(x => {
            return {
              mediaType: x.type,
              name: x.name,
              src: "ipfs://" + x.ipfs,
              xmbl: x.token[1],
              filehash: x.token[0],
              size: x.size.toString()
            }
          })
          if (metadata.files.length == tx.meta.fileids.length) {
            tx.meta.files = metadata.files
            delete tx.meta.fileids
            m('point', { 'header': `Minting`, 'text': 'with required file metadata.' })
            return mint(tx)
          }
        } else return mint(tx)
      },
      tx: async () => {
        let tx = payload.data.tx, key = payload.data.key, inputs = payload.data.inputs;
        console.log({ tx });
        tx.address = inputs.selectaddress[key].address;
        tx.chain = inputs.selectaddress[key].chain;
        tx.verification = key;
        ("point", {
          header: "Creating Transaction",
          text: `Sending ${JSON.stringify(tx.outputs)} from ${inputs.selectaddress[key].address
            }`,
          type: "update",
        });
        tx.inputs = [];
        // TODO encrypt with cloud public key
        return store
          .dispatch("api", {
            address: store.state.cloudurl + "createtx",
            verb: "post",
            data: tx,
          })
          .then((x) => {
            if (x.data.traceback) {
              store.commit("point", {
                header: "Transaction Failed",
                text: JSON.stringify(x.data.traceback),
                sticky: true,
                type: "warn",
              });
            } else {
              store.commit("point", {
                header: "Transaction Created",
                text: x.data,
              });
            }
            if (!tx.submit) {
              const txid = x.data[0];
              let savetx = {
                cbor: x.data[1],
                chain: tx.chain,
                outputs: tx.outputs,
              };
              let userkeys =
                store.state.users[store.state.auth.uid].keys;
              // this.$set(this.disabled, key, false);
              userkeys[key].txs = userkeys[key].txs || {};
              Vue.set(userkeys[key].txs, txid, savetx);
              store.dispatch("update", { type: "keys", keys: userkeys });
              return x.data[1]
            } else {
              return x.data
            }
          })
          .catch(e => e);
      },
      fee: async () => { // payload.data = {tx}
        const size = (new TextEncoder().encode(JSON.stringify(payload.data.tx))).length
        return Math.round(88.888 * size)

      }
    }
    return await c[payload.type](payload.data).then(x => x)
  },
  async delete(state, payload) {
    // TODO probably query the delete function for proper deindexing
    if (store.state.debug) mu.log('delete', payload)
    if (payload.type === 'comments') {
      var commentRef = fbBase.collection(payload.type).doc(payload['commentsid'])
      commentRef.update({ [payload.id]: fb.firestore.FieldValue.delete() })
      Vue.delete(st.comments[payload['commentsid']], payload.id)
    } else if (payload.type === 'reputation') {
      var repRef = fbBase.collection(payload.type).doc(payload.id)
      repRef.update({ [payload.rid]: fb.firestore.FieldValue.delete() })
      Vue.delete(st.reputation[payload.id], payload.rid)
      Vue.delete(st.user[store.state.auth.uid].userreps, payload.id)
      store.dispatch('update', { type: 'user', id: store.state.auth.uid, data: st.user[store.state.auth.uid] })
      var tRef = fbBase.collection('reputation').doc(payload.id).collection('meta').doc('stats')
      return fb.firestore().runTransaction(function (t) {
        return t.get(tRef).then(function (sfDoc) {
          if (!sfDoc.exists) return
          var newCount = sfDoc.data().count - 1
          var totalQuality = Number(sfDoc.data().quality) - 5
          return t.set(tRef, { count: newCount, quality: totalQuality }, { merge: f })
        })
      })
    } else if (payload.type === 'files') {
      const ref = storage.ref().child(payload.user).child(payload.hash).child(payload.name)
      let after = () => fbusersbase.collection(store.state.auth.uid).doc('files').update({ [payload.hash]: fb.firestore.FieldValue.delete() })
      ref.delete().then(after()).catch(after())
    } else if (payload.type === 'keys') {
      fbusersbase.collection(store.state.auth.uid).doc('keys').update({ [payload.hash]: fb.firestore.FieldValue.delete() })
    } else {
      var itemRef = fbBase.collection(payload.type).doc(payload.id)
      var userRef = fbBase.collection('user').doc(store.state.auth.uid)
      return userRef.get().then(async function (userData) {
        var userDataVal = userData.data()
        var userItems = []
        userDataVal.items[payload.type].forEach(function (item) {
          item !== payload.id && userItems.push(item)
        })
        return itemRef.delete().then(function () {
          store.dispatch('indexer', [{}, payload.id, payload.type])
          userDataVal.items[payload.type] = userItems
          userRef.update(userDataVal).then(async () => {
            // await ut.deindex(payload, payload.id, payload.type)
            Vue.delete(st.manageData[payload.type], payload.id)
            return '*Deleted* ' + JSON.stringify(payload, null, 2)
          })
        })
      }).catch(function (error) {
        console.error('Error removing document: ', error)
      })
    }
  },
  detecttype(state, payload) {
    if (Array.isArray(payload)) return 'array';
    if (typeof payload === 'object' && !Array.isArray(payload) && payload !== null) return 'object';
    if (typeof payload === 'string' && isNaN(payload)) return 'string';
    if (!isNaN(+payload) && payload !== null) return 'number';
    if (typeof payload === 'boolean') return 'boolean';
    if (typeof payload === 'function') return 'function';
    if (payload == null) return 'null';
    return 'untyped'
  },
  export(state, payload) { // payload: {type, name, data}
    let exportData = payload
    var filename = ('EXPORT_' + store.state.app.basics.database + ' ' + exportData.type + '_' + exportData.name + '_' + new Date().toLocaleDateString() + '.json').norm()
    var element = document.createElement('a')
    // TODO make general, i.e. check export.data reasoning and remove
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(exportData.data || exportData)))
    element.setAttribute('download', filename)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  },
  import(state, payload) {
    console.log('importing config', payload)
    var reader = new FileReader();
    console.log(reader);
    reader.onload = ((file) => {
      let myblob = reader.readAsText(file);
      console.log(file, myblob);
      return e => {
        // console.log('what is e', e);
        let appdata = JSON.parse(e.target.result)
        var confirmation = confirm(
          "Import " +
          JSON.parse(e.target.result).basics["app name"] +
          " config? This will overwrite the current app config."
        );
        appdata.user = store.state.app.user
        appdata.owner = store.state.auth.uid
        appdata.ownedBy = store.state.auth.uid
        appdata.basics.database = store.state.app.basics.database
        confirmation && appdata.basics["app name"]
          && state.dispatch("update", {
            type: "app",
            data: appdata
          }).then(() => {
            location.reload()
          })
      }
    })(payload.files[0]);
  },
  async indexer(state, [obj, id, type, olditem]) {
    const wb = fb.firestore().batch()
    let index = {}, dbindex, tally = 0
    fbBase.collection('index').doc(type).get().then(x => {
      dbindex = !x.exists ? {} : x.data()
      let indexloop = async (loopobj, keys) => {
        tally++
        await store.dispatch('detecttype', loopobj).then(typ => {
          if (typ === 'string') {
            let loopobjindex = _.get(dbindex, [...keys, loopobj])
            tally--
            _.set(index, [...keys, loopobj], loopobjindex ? Array(...new Set([...loopobjindex, id])) : [id])
          }
          else if (typ === 'object') {
            tally--
            Object.entries(loopobj).map(x => (indexloop(x[1], [...keys, x[0]])))
          }
          else if (typ === 'array') {
            tally--
            loopobj.map(x => indexloop(x, keys))
          }
          else tally--
          if (tally == 0) {
            let dif = diff(olditem, obj)

            Object.keys(dbindex).length > 0 && dif.map(d => {
              if (JSON.stringify(d.path) !== JSON.stringify(['created']) && JSON.stringify(d.path) !== JSON.stringify(['history']) && JSON.stringify(d.path) !== JSON.stringify(['edited']) && d.kind === 'E') {

                if (typeof d.path[d.path.length - 1] == 'number' && d.lhs && d.lhs.length > 0) {
                  let apath = d.path
                  apath.splice(d.path.length - 1, 1)
                  _.get(dbindex, apath)[d.lhs] && _.get(dbindex, apath)[d.lhs].splice(_.get(dbindex, apath)[d.lhs].indexOf(id), 1)
                }
                else {
                  console.log(d, dbindex, _.get(dbindex, d.path));
                  _.get(dbindex, d.path) && _.get(dbindex, d.path)[d.lhs] && _.get(dbindex, d.path)[d.lhs].splice(_.get(dbindex, d.path)[d.lhs].indexOf(id), 1)
                }
              }
              else if (JSON.stringify(d.path) !== JSON.stringify(['created']) && JSON.stringify(d.path) !== JSON.stringify(['history']) && JSON.stringify(d.path) !== JSON.stringify(['edited']) && d.kind === 'A') {
                if (d.item.kind === 'D') {
                  _.get(dbindex, d.path)[d.item.lhs] && _.get(dbindex, d.path)[d.item.lhs].splice(_.get(dbindex, d.path)[d.item.lhs].indexOf(id), 1)
                }
              }
            })
            wb.set(fbBase.collection('index').doc(type), dbindex)
            wb.set(fbBase.collection('index').doc(type), index, { merge: t }).commit()
          }
        })
      }
      Object.keys(obj).map((x, xi) => {
        index[x] = {}
        !['created', 'type', 'id', 'history', 'edited'].includes(x) && indexloop(obj[x], [x], xi === Object.keys(obj).length - 1 && 'last')
      })
    })
  },
  async init(state, styleonly, stateonly) {
    if (styleonly) {
      // console.log('styleonly', arguments)
      Object.assign(s, state)
    }
    if (stateonly) {
      // console.log('stateonly', arguments)
      Object.assign(s, state)
    }
    console.groupCollapsed('Initializing state')
    return fbBaseConfig.get().then((defaults) => {
      let dd = defaults.data()
      Object.entries(dd).map(d => Vue.set(s, d[0], d[1]))
      s.cloudurl = s.dev ? 'http://localhost:5000/xmba-cloud-api/us-central1/' : 'https://us-central1-xmba-cloud-api.cloudfunctions.net/'
      s.prohibitedProps.push(...s.abilityTypes)
      // Array('object', 'array', 'string').map(x => s.initializestate[x].map(y => Vue.set(s, y, x == 'object' ? {} : x == 'array' ? [] : '')))
    })
      .then(() => {
        return fbBase.get().then(async (data) => {
          console.log('...loading data...')
          if (data.exists) {
            var app = data.data().app
            console.log('...app config...', app.basics.database)

            app.forms = {}
            app.itemTypes = []
            if (app.basics.items) {
              console.log('...items config...')
              console.table(app.basics.items)
              app.basics.items.forEach((item) => {
                Vue.set(app.forms, item.name, {
                  forms: item.forms,
                  name: item.name,
                  submit: {
                    method: 'create',
                    type: item.name
                  }
                })
                app.itemTypes.push(item.name)
              })
            }
            mu.setState(s, {
              prop: 'app',
              val: app
            })

            // backwards compatibility
            if (!s.app.advanced) s.app.advanced = {}
            Array('functions', 'hooks', 'roles', 'api').map((t) => {
              if (s.app.basics[t]) {
                mu.set(s, { keys: ['app', 'advanced', t], val: s.app.basics[t] })
              }
              if (!s.app.advanced[t]) {
                mu.set(s, { keys: ['app', 'advanced', t], val: {} })
              }
            })

            // APPLY META
            console.log('...applying types, meta data, and styles...')
            // TODO fix type system: mu.typei(s)
            Vue.set(s.show, 'app', t)
            mu.setMeta(st)
            mu.setStyle(st)
            return s.app
          } else { // new app
            return axios.get('https://api.nasa.gov/planetary/apod?api_key=abg7Dc84znTXEuDGI80y1hYHiTqcRwXBeIt6JCtR')
              .then((result) => {
                s.models.iform.app.forms[1].inputs[0].default = result.data.url
                mu.setState(s, {
                  prop: 'app',
                  val: {
                    basics: {
                      database: 'fresh',
                      modules: s.modules
                    },
                    advanced: {},
                    style: {
                      'background-image': result.data.url,
                      'background-color': '#f2f2f0',
                      'button': '',
                      'color': '#191900',
                      'container': '#e2e2e0',
                      'indicate': '#bb8538',
                      'navbar': '#f2f2f0',
                      'sub-container': '#f2f2f0',
                      'success': '#93c83d',
                      'update': '#452f91',
                      'warn': '#e44233'
                    },
                    type: 'fresh',
                    version: 'v' + s.version
                  }
                })
                // act.create(s, s.app)
              })
          }
        }, (err) => {
          mu.setState(s, {
            prop: 'show',
            prop2: 'maintenance',
            val: err
          })
        })
      })
      .then(async () => {
        let typesindex = {}
        console.log('...setting type system lexicon...');
        fbBaseLex.doc('types').get().then(d => {
          Object.entries(d.data()).map(async a => {
            typesindex[a[1].f] = {}
            Object.entries(a[1]).map(b => {
              typesindex[a[1].f][b[1]] = a[0] + b[0]
            })
          })
          Vue.set(s, 'lexicon', typesindex)
        })
        console.log('...setting current user...', s.auth.uid);
        act.query(s, {
          type: "user",
          id: s.auth.uid,
        })
        // store.dispatch("query", {
        //   type: "user",
        //   id: s.auth.uid,
        // });
        return fbBase.collection('user').get()
          .then(async (data) => {
            let users = {}
            data.docs.forEach(function (doc) {
              users[doc.id] = doc.data()
              users[doc.id].roles = users[doc.id].roles || []
            });
            mu.setState(s, { prop: 'userlist', val: users })
            console.log('...setting other users...', Object.keys(s.userlist).length);

            let hook = s.app.advanced.hooks && s.app.advanced.hooks.app;
            // let name = hook && (hook.fun || hook.get ? hook.get.name : f)
            hook && act.run(s, {
              from: 'App loaded ',
              if: hook.if || [],
              fun: hook.fun,
              payload: hook.getpayload || hook.payload || {},
            }).then(d => d)
            // hook && store.dispatch('run', {
            //   from: 'App loaded ',
            //   if: hook.if || [],
            //   fun: hook.fun,
            //   payload: hook.getpayload || hook.payload || {},
            // }).then(d => d)
            Vue.set(s.show, 'app', t)
            return console.groupEnd('Initializing state')
          })
      })

  },
  async ipfs(state, payload) {
    let type = store.dispatch('detecttype', payload).then(t => t)
    let str = ['object', 'array'].includes(await type) ? JSON.stringify(payload)
      : String(payload)
    return ut.ipfs(str)
  },
  notify(type, message, to, from, link, id, subMessage, actions) {
    if (s.debug) mu.log('notify()', arguments)
    var notifyObj = {
      type: 'notification',
      data: {
        actions,
        id,
        from,
        link,
        message,
        subMessage,
        to,
        type // types include specific item being watched, system, billing, events, jobs, crypto, and orders
      }
    }
    act.create(s, notifyObj)
    mu.point(s, {
      header: type,
      text: message,
      link: link,
      sticky: t
    })
    return notifyObj
  },
  async query(state, payload) {
    mu.log('query', payload)
    Object.entries(payload).map((prop) => {
      /*
      // STRATEGY 'p__' represents a point in state.
      */
      if (typeof prop[1] === 'string' && prop[1].indexOf("p__") === 0) {
        let point = store.state
        prop[1].split('state.')[1].split('.').forEach((key) => {
          point = !+key ? point[key] : point[+key]
        })
        payload[prop[0]] = point
      }
      /**/
    })

    // TODO remove fb call until required 
    var refObj = {}
    var refArr = ['image', 'name', 'title']
    var getRef = function (refType) {
      refObj[refType] = fbBase.collection('ref').doc(refType)
      refObj[refType].get().then((snap) => {
        Vue.set(store.state.ref, refType, snap.exists ? snap.data() : {})
      })
    }

    refArr.forEach((ref) => { getRef(ref) })
    if (payload.type === 'reputation' && payload.id) {
      let reppromise = new Promise((resolve) => {
        return fbBase.collection(payload.type).doc(payload.id).get()
          .then((doc) => {
            if (doc.exists) {
              const returnReps = doc.data()
              store.state.reputation[payload.id] = store.state.reputation[payload.id] || {
                data: {}, meta: {}
              }
              store.commit('set', { keys: ['reputation', payload.id, 'data'], val: returnReps })

              return fbBase.collection(payload.type)
                .doc(payload.id).collection('meta').doc('stats')
                .onSnapshot({
                  // Listen for document metadata changes
                  includeMetadataChanges: t
                }, function (doc) {
                  if (doc.exists) {
                    const returnMetaReps = doc.data()
                    store.state.reputation[payload.id] = store.state.reputation[payload.id] || {}
                    store.commit('set', { keys: ['reputation', payload.id, 'meta'], val: returnMetaReps })
                    // Vue.set(store.state.reputation[payload.id], 'meta', returnMetaReps)
                    // mu.increment(store.state)
                    resolve(returnReps)
                  }
                })
            }
          })
      })
      return reppromise.then((x) => x)

    } else if (payload.type === 'list') {
      return fbBase.collection(payload.collection).limit(payload.limit || 100).get().then((docs) => {
        st.items[payload.collection] = {}
        docs.docs.map(async (doc) => {
          var docData = doc.data();
          // todo, remove all timestamps with a general admin function created instead of timestamps upkeep
          docData.created = docData.created || docData.timestamps[0];
          (docData.basics.published ||
            docData.user == store.state.auth.uid ||
            (store.state.app.user.includes(store.state.auth.uid) ||
              (store.state.app.advanced.roles.admin &&
                store.state.app.advanced.roles.admin.members &&
                store.state.app.advanced.roles.admin.members.includes(
                  store.state.auth.uid
                )))) ? Vue.set(store.state.items[payload.collection], doc.id, docData) : null

        })
        return st.items[payload.collection]
      }).catch(function (error) {
        console.log('Error getting document:', error)
      })
    } else if (payload.type === 'manage' && st.auth.uid) {
      var itemRef = fbBase.collection(payload.collection)
      return fbBase.collection('user').doc(st.auth.uid).get().then(function (DocumentSnapshot) {
        var userDoc = DocumentSnapshot.data()
        var itemList = {}
        if (userDoc.items && userDoc.items[payload.collection]) {
          st.manageData[payload.collection] = {}
          return Promise.all(userDoc.items[payload.collection].map(async (doc) => {
            return await itemRef.doc(doc).get().then(function (docData) {
              var manData = docData.data()
              if (manData) {
                itemList[manData.id] = manData
                Vue.set(st.manageData[payload.collection], manData.id, manData)
                return st.manageData
              } else return
            })
          })).then(() => {
            return itemList
          })
        }
      }).catch(function (error) {
        console.log('Error getting document:', error)
      })
      // return fbBase.collection(payload.type).doc()
    } else if (payload.type === 'email') {
      return fbBase.collection('user').doc(payload.id).collection('private').doc('content').get().then((doc) => {
        var email = doc.data().email
        return email
      })
    } else if (payload.type === 'event' || payload.type === 'job') {
      return fbBase.collection('relate')
        .doc(payload.type + 's')
        .collection(payload.itemType)
        // .limit(payload.limit || 100)
        .doc(payload.id)
        .onSnapshot({
          // Listen for document metadata changes
          includeMetadataChanges: t
        }, function (doc) {
          var returnDoc = doc.data()
          if (store.state.events[payload.itemType]) {

            // TODO Add scheduling system into here

            Vue.set(store.state.events[payload.itemType], payload.id, returnDoc)
          } else {
            Vue.set(store.state.events, payload.itemType, { [payload.id]: returnDoc })
          }
          return returnDoc
        })
    } else if (payload.type === 'maintenance') {
      try {
        return axios.post('https://us-central1-p3c-prsprty.cloudfunctions.net/maintenance', { data: { reload: f, params: 'hello', otherAppStuff: 'yeah' } }).then((data) => {
          return data.data
        })
      }
      catch (error) { console.log(error) }
    } else if (payload.type === 'orders') {
      if (store.state.counts.ordersin > 19) return store.state.counts.ordersin = f
      if (!store.state.counts.ordersin) store.state.counts.ordersin = 0
      store.state.counts.ordersin = store.state.counts.ordersin + 1
      if (!store.state.user[payload.user] && store.state.counts.ordersin < 20) return setTimeout(() => { store.dispatch('query', payload) }, 50 * store.state.counts.ordersin)
      if (store.state.user[payload.user] && store.state.user[payload.user].orders) {
        return store.state.user[payload.user].orders.forEach((order) => {
          return fbBase.collection(payload.type).doc(order).onSnapshot({
            // Listen for document metadata changes
            includeMetadataChanges: t
          }, function (doc) {
            const specificOrder = doc.data()
            return specificOrder.paid === 'NEW' ? (() => {
              return QR.toDataURL(`${specificOrder.payment.order.currency || 'bitcoin'}:${specificOrder.payment.charge[specificOrder.payment.order.currency || 'bitcoin'].wallet}?${specificOrder.payment.order.currency === 'ethereum' ? 'value' : 'amount'}=${specificOrder.payment.charge[specificOrder.payment.order.currency || 'bitcoin'].amount}`)
            })().then((qr) => {
              specificOrder.qr = qr
              return store.commit('set', { keys: ['orders', doc.id], val: specificOrder })
              // Vue.set(store.state.orders, doc.id, specificOrder)
            }) : store.commit('set', { keys: ['orders', doc.id], val: specificOrder })//  Vue.set(store.state.orders, doc.id, specificOrder)
          })
        })
        // return store.state.orders
      }
    } else if (payload.type === 'sales') {
      if (store.state.counts.salesin > 19) return store.state.counts.salesin = f
      if (!store.state.counts.salesin) store.state.counts.salesin = 0
      store.state.counts.salesin = store.state.counts.salesin + 1
      if (!store.state.user[payload.user] && store.state.counts.salesin < 20) return setTimeout(() => { store.dispatch('query', payload) }, 50 * store.state.counts.salesin)
      store.state.user[payload.user] && store.state.user[payload.user].sales && Object.keys(store.state.user[payload.user].sales).forEach((order) => {
        fbBase.collection('orders')
          .doc(order)
          .onSnapshot({
            // Listen for document metadata changes
            includeMetadataChanges: t
          }, async (doc) => {
            var orderObj = doc.data()
            var orderTotal = 0
            var completeCheck = []
            orderObj.items.forEach((item) => {
              orderTotal = orderTotal + (item.qty * item.purchase.cost) + item.purchase['shipping and handling']
              if (item.status !== 'delivered') {
                completeCheck.push(item.status)
              }
            })
            Vue.set(store.state.sales, doc.id, orderObj)
            Vue.set(store.state.sales[doc.id], 'complete', completeCheck.length === 0)
            Vue.set(store.state.sales[doc.id], 'paid', orderObj.paid)
            Vue.set(store.state.sales[doc.id], 'total', orderTotal)
          })
      })
    } else if (payload.type === 'secret-event' || payload.type === 'secret-item') {
      return fbBase.collection(payload.collection).doc(payload.id).get().then((itemData) => {
        st.secretItem = itemData.data()
        return itemData.data()
      })
    } else if (payload.type === 'user') {
      if (!payload.id) return f
      fbBase.collection(payload.type).doc(payload.id).get().then(async (userData) => {
        let user = userData.data()
        // Get user subscriptions
        st.app.itemTypes ? st.app.itemTypes.forEach((itemType) => {
          Object.keys(st.related).forEach((abilityType) => {
            fbBase.collection(payload.type).doc(payload.id).collection('relate').doc(abilityType).collection(itemType).doc('status').get().then((relateData) => {
              if (relateData.exists) {
                var related = relateData.data()
                if (st.related[abilityType]) {
                  mu.setState(st.related, { prop: abilityType, prop2: itemType, val: related })
                } else {
                  st.related[abilityType] = {}
                  mu.setState(st.related[abilityType], { prop: itemType, val: related })
                }
              }
            })
          })
        }) : console.log('user error', payload)
        if (JSON.stringify(user) === JSON.stringify(st.users[payload.id])) {
          return
        }
        var itemArr = user[payload.collection || payload.type] || []
        if (user.cart) {
          Object.keys(user.cart).forEach((cart) => {
            st.counts.cart = st.counts.cart + 1
            if (user.cart[cart] === null) {
              delete user.cart[cart]
            }
          })
        }
        if (payload.id === st.auth.uid) {
          act.query(st, { type: 'value', id: st.auth.uid })
          fbBase.collection('user').doc(st.auth.uid).onSnapshot({
            includeMetadataChanges: t
          }, (doc) => {
            let userdata = doc.data()
            Vue.set(st.user[st.auth.uid], 'auctions', userdata.auctions);
            ['notifications'].forEach((query) => {
              if (userdata[query]) {
                act.query(state, {
                  type: query,
                  data: userdata[query]
                })
              }
            })
            // TODO rethink onboarding again
            // if (!doc.data().notifications) {
            //   store.state.welcomeNotificationSent ? act.notify('Welcome', 'You\'ve made a wise choice. Tap this notification to enter your dashboard', [store.state.auth.uid], 'system', '/dashboard', f) : null
            //   store.state.welcomeNotificationSent = t
            // }
          })
        }
        user.image = user.image || s.defaults.userimage
        user.name = user.name || 'Glootie'
        // user.files = await fbusersbase.collection(store.state.auth.uid).doc('files').get().then(x => {
        //   return x.data()
        // })
        user.files = fbusersbase.collection(store.state.auth.uid).doc('files').onSnapshot(x => {
          store.commit('set', { keys: ['user', store.state.auth.uid, 'files'], val: x.data() })
          return x.data()
        })
        user.keys = fbusersbase.collection(store.state.auth.uid).doc('keys').onSnapshot(x => {
          store.commit('set', { keys: ['user', store.state.auth.uid, 'keys'], val: x.data() })
          return x.data()
        })
        user[payload.collection || payload.type] = []
        if (!itemArr.forEach) {
          itemArr = Object.keys(itemArr)
        }
        if (itemArr.length > 0) {
          itemArr.forEach((item, indexKey) => {
            fbBase.collection(payload.collection || payload.type).doc(item).get().then((itemData) => {
              if (!itemData.exists) {
                Vue.set(st.users, payload.id, user)
                Vue.set(st.user, payload.id, user)
              } else {
                user[payload.collection || payload.type].push(itemData.id)
                st.users[payload.collection || payload.type][item] = itemData.data()
                if (indexKey + 1 === itemArr.length) {
                  Vue.set(st.users, payload.id, user)
                  Vue.set(st.user, payload.id, user)
                }
              }
            })
          })
        } else {
          Vue.set(st.users, payload.id, user)
          Vue.set(st.user, payload.id, user)
        }
      })
      st.auth.uid ? fbBase.collection('user').doc(st.auth.uid).collection('relate').doc('connect').collection('user').doc('status').get().then((relateData) => {
        if (relateData.exists) {
          var related = relateData.data()
          if (st.related['connect'].user) {
            mu.setState(store.state.related, { prop: 'connect', prop2: 'user', val: related })
          } else {
            // st.related['connect'].user = {}
            mu.setState(st.related['connect'], { prop: 'user', val: related })
          }
        } else {
          st.related['connect'].user = {}
        }
      }) : mu.log('Undefined User')
      st.auth.uid ? fbBase.collection('user').doc(st.auth.uid).collection('private').doc('content').get().then((pvt) => {
        if (pvt.exists) {
          let pvtdata = pvt.data()
          mu.set(st, { keys: ['user', st.auth.uid, 'payouts and funding'], val: pvtdata['payouts and funding'] || {} })

          // var related = pvtdata.data()
          // if (st.related['connect'].user) {
          //   mu.setState(store.state.related, { prop: 'connect', prop2: 'user', val: related })
          // } else {
          //   // st.related['connect'].user = {}
          //   mu.setState(st.related['connect'], { prop: 'user', val: related })
          // }
        } else {
          st.related['connect'].user = {}
        }
      }) : mu.log('Undefined User')
      return [st.users, st.user]
    } else if (payload.type === 'comments') {
      fbBase.collection(payload.type)
        // .limit(payload.limit || 100)
        .doc(typeof payload.id === 'number' ? payload.comment.id : payload.id)
        .onSnapshot({
          // Listen for document metadata changes
          includeMetadataChanges: t
        }, function (doc) {
          if (doc.exists) {
            const returncomments = doc.data()
            Vue.set(store.state.comments, payload.id, returncomments)
            return returncomments
          }
        })
      return store.state.comments[payload.id]
    } else if (payload.type === 'msgs') {
      if (!store.state.user[store.state.auth.uid] && !store.state.user[store.state.auth.uid].msgs) {
        await act.query('user', { id: store.state.auth.uid })
      }
      var unseenMessageArr = []
      payload.data = payload.data || store.state.user[store.state.auth.uid].msgs;
      store.state.user[store.state.auth.uid].msgs = store.state.user[store.state.auth.uid].msgs || {};

      let msgpromise = new Promise((resolve) => {
        return fbBase.collection('msgs')
          .where('users', 'array-contains', store.state.auth.uid)
          .onSnapshot({ includeMetadataChanges: t }, (docs) => {
            docs.docs.map((doc, doci) => {
              if (doc.exists) {
                var message = doc.data()
                var userNames = []
                message.users.forEach((userid) => {
                  userNames.push(store.state.ref.name[userid])
                })
                message.userNames = userNames
                // store.state.msgs[message.id] = message
                store.commit('set', { keys: ['msgs', message.id], val: message })
                if (store.state.user[store.state.auth.uid].msgs[message.id] === 'unseen') {
                  unseenMessageArr.push(message.id)
                }
              }
              if (doci === docs.docs.length - 1) {
                Vue.set(store.state, 'msgs', store.state.msgs)
                mu.setState(store.state, {
                  keys: ['counts', 'messages'],
                  val: unseenMessageArr.length
                })
                mu.set(store.state, {
                  keys: ['componentKeys', 'message'],
                  val: store.state.componentKeys.message + 1
                })
                resolve(store.state.msgs)
              }
            })
          });
      })
      return msgpromise.then((x) => x)

    } else if (payload.type === 'notifications') {
      payload.data = payload.data || store.state.user[store.state.auth.uid].notifications
      Object.keys(payload.data).forEach((item) => {
        fbBase.collection('notifications').doc(item)
          .onSnapshot({
            includeMetadataChanges: t
          }, (doc) => {
            if (doc.exists) {
              var notification = doc.data()
              notification.actions = notification.actions || store.state.actions[notification.type]
              Vue.set(st.notifications, item, notification)
            }
            var unseen = []
            Object.keys(st.notifications).forEach((notification) => {
              if (!store.state.notifications[notification].seen) {
                unseen.push(notification)
              }
            })
            store.state.counts.notifications = unseen.length
          })
      })
      return st.notifications
    } else if (payload.type === 'item') {
      return fbBase.collection(payload.collection || payload.type).doc(payload.id).get().then(async (itemData) => {
        if (itemData.exists) {
          var goods = itemData.data()
          !store.state.items[payload.collection] ? store.state.items[payload.collection] = {} : null
          // var updateItem = { items: t, prop: payload.collection || payload.type, prop2: payload.id, val: goods }
          store.commit('set', { keys: ['item'], val: goods })
          store.commit('set', { keys: ['items', payload.collection || payload.type, payload.id], val: goods })
          // mu.setState(store.state, updateItem)
        }
        fbBase.collection('relate').doc(payload.collection || payload.type).collection(payload.id).get().then((snapshot) => {
          if (snapshot.exists) {
            snapshot.forEach((doc) => {
              var relateData = doc.data()
              var relateValues = {}
              Object.keys(relateData).forEach((relateKey) => {
                relateValues[relateKey] = relateData[relateKey].length
              })
              mu.setState(store.state, { prop: 'relateValues', prop2: payload.id, val: relateValues })
            })
          }
        })
        return goods
      })
    } else if (payload.type === 'tags') {
      return fbBase.collection('index').doc(payload.collection).get().then(function (querySnapshot) {
        var tagGroup = querySnapshot.data()
        store.state.tags[payload.collection] = store.state.tags[payload.collection] || {}
        store.state.tags[payload.collection][payload.tag] = store.state.tags[payload.collection][payload.tag] || {}
        tagGroup[payload.type][payload.tag].forEach(function (iitemid) {
          if (store.state.items[payload.collection] && store.state.items[payload.collection][iitemid]) {
            store.state.tags[payload.collection][payload.tag][iitemid] = store.state.items[payload.collection][iitemid]
          } else {
            fbBase.collection(payload.collection).doc(iitemid).get().then((item) => {
              store.state.tags[payload.collection][payload.tag][iitemid] = item.data()
            })
          }
        })
        Vue.set(store.state.tags[payload.collection], payload.tag, store.state.tags[payload.collection][payload.tag])
        return store.state.tags[payload.collection][payload.tag]
      }).catch(function (error) {
        console.log('Error getting document:', error)
      })
    } else if (payload.type === 'value') {
      return fbBase.collection('user').doc(store.state.auth.uid).collection(payload.type).get().then((data) => {
        data.docs.forEach((doc) => {
          return mu.setState(store.state.value, { prop: doc.id, val: doc.data() })
        })
      })
    } else if (payload.type === 'logs') {
      const logs = await fbBase.collection('logs').get()
      const emails = await fbBase.collection('email').get()
      return {
        webhooks: logs.docs.map(doc => doc.data()),
        emails: emails.docs.map(doc => doc.data())
      };
    } else {
      return { error: 'Unrecognizd query type or lacking id' }
    }
  },
  relate(state, payload) {
    if (store.state.debug) mu.log('relate', payload)
    if (!store.state.auth.uid) {
      store.state.show.auth = t
      return mu.log('Must be logged in', 'Please authenticate.')
    }
    if (st.related[payload.type] && st.related[payload.type][payload.itemType] && st.related[payload.type][payload.itemType][payload.id]) {
      var oldStatus = st.related[payload.type][payload.itemType][payload.id]
    }
    if (payload.secret) {
      var salt = encodeURIComponent(payload.id + ' ' + st.auth.uid)
      // Zipper security, secure string implimentation
      payload.salt = ut.strToNum(salt)
      let wb = fb.firestore().batch()
      wb.set(fbBase.collection('user').doc(st.auth.uid).collection('relate').doc(payload.type), { [payload.id]: payload.status }, { merge: t }).commit().then(() => {
        mu.setState(store.state, { prop: 'related', prop2: payload.type, val: { [payload.id]: payload.status } })
        act.query(state, { type: payload.type, id: payload.id })
        return ut.crypto('encrypt', payload)
      })
    } else {
      var tRef = fbBase.collection('relate').doc(payload.type).collection(payload.itemType).doc(payload.id)
      return fb.firestore().runTransaction(function (t) {
        return t.get(tRef).then(function (sfDoc) {
          if (!sfDoc.exists) {
            return t.set(tRef, { [payload.status]: [st.auth.uid] }, { merge: t })
          } else {
            let sfDocObject = sfDoc.data()
            if (!payload.status) {
              t.set(tRef, { [oldStatus]: [...sfDocObject[oldStatus].splice(...sfDocObject[oldStatus].indexOf(st.auth.uid))] }, { merge: t })
            } else if (sfDocObject[payload.status] && [...sfDocObject[payload.status]].indexOf(st.auth.uid) > -1) {
              t.set(tRef, { [payload.status]: [...sfDocObject[payload.status]] }, { merge: t })
            } else if (!sfDocObject[payload.status]) {
              t.set(tRef, { [payload.status]: [st.auth.uid] }, { merge: t })
            } else {
              t.set(tRef, { [payload.status]: [...sfDocObject[payload.status], st.auth.uid] }, { merge: t })
            }
            if (oldStatus && sfDocObject[oldStatus].indexOf(st.auth.uid) > -1) {
              sfDocObject[oldStatus].pop(sfDocObject[oldStatus].indexOf(st.auth.uid))
              t.set(tRef, { [oldStatus]: sfDocObject[oldStatus] }, { merge: t })
            }
          }
        })
      }).then(function () {
        let wb = fb.firestore().batch()
        return wb.set(fbBase.collection('user').doc(st.auth.uid).collection('relate').doc(payload.type).collection(payload.itemType).doc('status'), { [payload.id]: payload.status }, { merge: t }).commit().then(() => {
          st.related[payload.type] = st.related[payload.type] || {}
          st.related[payload.type][payload.itemType] = st.related[payload.type][payload.itemType] || {}
          return mu.setState(store.state.related, { prop: payload.type, prop2: payload.itemType, val: { [payload.id]: payload.status } })
          // return act.query(state, {type: payload.type, id: payload.id, itemType: payload.itemType})
        })
      }).catch(function (error) {
        console.log('Transaction failed: ', error)
      })
    }
  },
  async 'if'(state, payload) {
    console.log('running conditional |if|', payload);
    // if (payload.if) {
    // d('if', payload.if).then(x=>x)
    //todo check for and run functions
    //todo check for location
    let conditionalarray = []
    const compare = {
      '==': (left, right) => (console.log(left, right, left == right), left == right),
      '!=': (left, right) => left != right,
      '>': (left, right) => left > right,
      '>=': (left, right) => left >= right,
      '<': (left, right) => left < right,
      '<=': (left, right) => left <= right,
      'includes': (left, right) => left.includes(right),
      'excludes': (left, right) => !left.includes(right),
      // TODO add the other comparables, undefined compare, and deep checks
    }
    const resp = await Promise.all(payload.map(async (x, i) => {
      console.log('Mapping condition promises', { i, x });
      if (x.compare.length == 0) return true
      // HERE finish conditional types
      const conditionaltypes = {
        'value': async (v) => v,
        'fn': async (v) => await d('run', v).then(async z => {
          return await z
        }),
        'state': async (v) => _.get(s, v),
        'local': async (v) => v,
      }


      if (i % 2 == 0) {

        const values = ['left', 'right']
          .map(async y => await conditionaltypes[x[y].type](x[y].value)
            .then(v => v))
        const vals = await Promise.all(values)
          .then(vls => vls)

        if (x.compare in compare) {
          conditionalarray[i] = compare[x.compare](vals[0], vals[1])
        }
        console.log({ conditionalarray })

        // let values = { left: x.left.value, right: x.right.value }

        // if (x.left.location) values.left = _.get(types, x.left.location)
        // if (x.right.location) values.right = _.get(types, x.right.location)
        // if (x.left.value) values.left = x.left.value
        // if (x.right.value) values.right = x.right.value
        // if (x.left.function) (x.left.function.from = payload.fun.name.toUpperCase() + ' in ' + payload.from, values.left = await store.dispatch('run', x.left.function).then(d => d))
        // if (x.right.function) (x.right.function.from = payload.fun.name + ' in ' + payload.from, values.right = await store.dispatch('run', x.right.function).then(d => d))
        // // TODO FIX bug for refactoring i.e. conditionalarray[i] = compare[x.compare](values.left, values.right);
        // if (x.compare in compare) conditionalarray[i] = compare[x.compare](values.left, values.right)
      } else conditionalarray[i] = x

    })).then(() => {
      let bool = t
      let conditionalchain = {}
      let conditioncheck = async (logic, val) => {
        if (conditionalarray.length === 1) {
          bool = conditionalarray[0]
        } else if (!logic && !val) {
          if (conditionalarray[1] == '&&') bool = (conditionalarray[0] && conditionalarray[2])
          if (conditionalarray[1] == '||') bool = (conditionalarray[0] || conditionalarray[2])
        } else {
          if (logic == '&&') bool = (bool && val)
          if (logic == '||') bool = (bool || val)
        }
      }

      conditioncheck()
      conditionalarray.map((x, i) => {
        if (i < 3) return
        if (i % 2 !== 0) conditionalchain.logic = x
        if (i % 2 === 0) {
          conditionalchain.val = x
          conditioncheck(conditionalchain.logic, conditionalchain.val)
        }
      })
      return bool ? (console.log('Conditions met'), t) : (console.log('%c ERROR | Conditions not met.', 'color: red', 'Conditional', payload, conditionalarray), f)
    })
    console.log('if response', { resp });
    return resp
    // }
    // else return payload
  },
  async run(context, payload) {
    /* Running function
    Takes a pre-configured function from 
    ``` state.app.advanced.functions ```
    Each app function is a collection of 1 or more commands.
    Commands are typed: app, custom, etc. 
    They are assigned inputs from the user or from previous outputs */
    console.log(payload.fun);
    let runfn = ut.findcurrentfunction(payload.fun)
    const start = Date.now()

    if (payload.props) { this.props = payload.props }
    if (!runfn && !payload.get) return console.info('Unavailable function from ', payload)

    // backwards compatibility 
    if (!runfn && payload.get) {
      runfn = payload.get
    }
    if (!payload.payload && payload.getpayload) {
      payload.payload = payload.getpayload
    }

    // Setup logging group
    console.groupCollapsed('%c (ƒ) ', 'color:green', runfn.name.toUpperCase() + (payload.from ? ' > from ' + payload.from : ''))
    console.table(runfn.commands, ['type', 'method'])
    payload.if && console.info('Conditions', payload.if)
    console.info('Inputs', payload.payload)

    // TODO test asyncronicity

    // run hook function if present
    if (payload.hook) {
      await store.dispatch('run', payload.hook)
    }


    /* Get payload value from state
    STRATEGY 'p__' represents a point in state.
    */
    Object.entries(payload.payload).map((prop) => {
      if (typeof prop[1] === 'string' && prop[1].indexOf("p__") === 0) {
        let point = store.state
        prop[1].split('state.')[1].split('.').forEach((key) => {
          point = !+key ? point[key] : point[+key]
        })
        payload.payload[prop[0]] = point
      } else if (typeof prop[1] === 'string' && prop[1].indexOf("prop__") === 0) {
        payload.payload[prop[0]] = this.props[prop[1].split('prop__')[1]]
      }
    })

    // Setup runstate in/outs
    let runstate = {
      inputs: {
        payload: payload.payload,
      },
      state: runfn,
      outputs: {},
    };

    // Recursive function, calls each command in sequence then returns the last calculated value
    let ret = async (r, i) => {
      ((Array.isArray(r) && "array") || typeof r) !== runstate.outputs.push(r);

      if (runstate.state.commands[i + 1]) {
        console.log('%c OUTPUT >', 'color:blue', runstate.outputs[runstate.outputs.length - 1])
        return fun(i + 1)
      } else {
        Vue.set(runstate, "outputs", runstate.outputs)
        console.groupEnd('%c (ƒ in/out)', 'color: blue', runfn.name.toUpperCase())
        console.log('%c (ƒ DONE)', 'color: purple', runstate.state.name.toUpperCase(), "|", Date.now() - start, 'ms', '|')
        console.groupEnd('%c (ƒ) ', 'color:green', runfn.name.toUpperCase() + (payload.from ? ' > from ' + payload.from : ''))
        return runstate.outputs[runstate.outputs.length - 1]

      }
    };

    /* Command execution function 

    */
    let fun = async (i) => {
      let f = runstate.state.commands[i];
      let payload = i === 0 ? runstate.inputs.payload : {};

      // i+'___' is to allow multiple functions of same name
      Object.keys(runstate.inputs[i + '___' + f.method]).map((k) => {
        if (
          f.inputs[k] && f.inputs[k].target && typeof f.inputs[k].target === "string" && f.inputs[k].target.indexOf("p__") === 0
        ) {

          let point = store.state;
          f.inputs[k].target
            .split("state.")[1]
            .split(".")
            .forEach((key) => {
              point = !+key ? point[key] : point[+key];
            });
          f.inputs[k].target = point;
        }

        let output = f.inputs[k] && f.inputs[k].value.split("state.") || runstate.outputs[runstate.outputs.length - 1];
        let objstr = _.get(runstate, output[1] || output[0]); // TODO check this works for n commands
        payload[k] = runstate.inputs.payload[f.inputs[k].value] ||
          _.get(this, f.inputs[k].value) || objstr;

        payload[k] = f.inputs[k].value === 'static' ? f.inputs[k].static : f.inputs[k].target ? _.get(payload[k], f.inputs[k].target) : payload[k]
      });
      let payloadarray = []
      payload && Object.entries(payload).map((x) => {
        if (f.inputs[x[0]]) {
          payloadarray[f.inputs[x[0]].order] = f.inputs[x[0]].value === 'static' ? f.inputs[x[0]].static : x[1]
          payloadarray[f.inputs[x[0]].order] = payloadarray[f.inputs[x[0]].order] && payloadarray[f.inputs[x[0]].order].fun && payloadarray[f.inputs[x[0]].order].payload ? store.dispatch('run', payloadarray[f.inputs[x[0]].order]) : payloadarray[f.inputs[x[0]].order]
          if (payloadarray[f.inputs[x[0]].order] && payloadarray[f.inputs[x[0]].order].indexOf) {
            if (payloadarray[f.inputs[x[0]].order].indexOf('p__') == 0) {
              let point = store.state;
              payloadarray[f.inputs[x[0]].order]
                .split("state.")[1]
                .split(".")
                .forEach((key) => {
                  point = !+key ? point[key] : point[+key];
                });
              payloadarray[f.inputs[x[0]].order] = point;
            } else if (payloadarray[f.inputs[x[0]].order].indexOf('props__') == 0) {
              // payloadarray[f.inputs[x[0]].order] = props[payloadarray[f.inputs[x[0]].order].split('props__')[1]]
            }
          }
        }
      });
      if (i == 0) {
        console.groupCollapsed('%c (ƒ in/out)', 'color: blue', runstate.state.name.toUpperCase())
      }
      console.log(`%c ${i + 1} INPUT `, 'color:orange', runstate.state.commands[i].method + '()', payloadarray)
      if (f.type === "app") {
        return await store[f.method.split('.')[0]](f.method.split(".")[1], payload).then(d => ret(d, i))
      }
      if (f.type === "custom") {
        let fn = _.get(window, f.method);
        let d = await fn(...payloadarray) || payloadarray[payloadarray.length - 1];
        return ret(d, i);
      }
      if (f.type === "function") {
        store.dispatch('run', ...payloadarray || payloadarray[payloadarray.length - 1])
      }
    };

    // map commands to inputs
    runfn.commands.map((s, si) => {
      !runstate.inputs[s.method] ?
        Vue.set(runstate.inputs, si + '___' + s.method, {}) : null;
      Object.keys(s.inputs).map((i) => Vue.set(runstate.inputs[si + '___' + s.method], i, ""));
    });
    runstate.outputs = [];

    // Conditional Checks
    if (payload.if || payload.conditionals) {
      let conditionals = payload.if || payload.conditionals
      d('if', conditionals).then(x => x)
      let conditionalarray = []
      const compare = {
        ['=='](left, right) {
          return left === right
        },
        ['!='](left, right) {
          return left !== right
        },
        ['>'](left, right) {
          return left > right
        },
        ['>='](left, right) {
          return left >= right
        },
        ['<'](left, right) {
          return left < right
        },
        ['<='](left, right) {
          return left <= right
        },
        ['includes'](left, right) {
          return left.includes(right)
        },
        ['excludes'](left, right) {
          return !left.includes(right)
        },

        // TODO add the other comparables
      }
      const resp = await Promise.all(conditionals.map(async (x, i) => {
        if (i % 2 == 0) {
          let values = {}
// TODO finish conditionals
          // if (x.left.location) values.left = _.get(types, x.left.location)
          // if (x.right.location) values.right = _.get(types, x.right.location)
          if (x.left.value) values.left = x.left.value
          if (x.right.value) values.right = x.right.value
          if (x.left.function) (x.left.function.from = runfn.name.toUpperCase() + ' in ' + payload.from, values.left = await store.dispatch('run', x.left.function).then(d => d))
          if (x.right.function) (x.right.function.from = runfn.name + ' in ' + payload.from, values.right = await store.dispatch('run', x.right.function).then(d => d))
          // TODO FIX bug for refactoring i.e. conditionalarray[i] = compare[x.compare](values.left, values.right);
          x.compare == '==' ? conditionalarray[i] = compare['=='](values.left, values.right) : null
          x.compare == '!=' ? conditionalarray[i] = compare['!='](values.left, values.right) : null
          x.compare == '>' ? conditionalarray[i] = compare['>'](values.left, values.right) : null
          x.compare == '>=' ? conditionalarray[i] = compare['>='](values.left, values.right) : null
          x.compare == '<' ? conditionalarray[i] = compare['<'](values.left, values.right) : null
          x.compare == '<=' ? conditionalarray[i] = compare['<='](values.left, values.right) : null
          x.compare == 'includes' ? conditionalarray[i] = compare['includes'](values.left, values.right) : null
          x.compare == 'excludes' ? conditionalarray[i] = compare['excudes'](values.left, values.right) : null
        } else conditionalarray[i] = x

      })).then(() => {
        let bool = t
        let conditionalchain = {}
        let conditioncheck = async (logic, val) => {
          if (conditionalarray.length === 1) {
            bool = conditionalarray[0]
          } else if (!logic && !val) {
            if (conditionalarray[1] == '&&') bool = (conditionalarray[0] && conditionalarray[2])
            if (conditionalarray[1] == '||') bool = (conditionalarray[0] || conditionalarray[2])
          } else {
            if (logic == '&&') bool = (bool && val)
            if (logic == '||') bool = (bool || val)
          }
        }

        conditioncheck()
        conditionalarray.map((x, i) => {
          if (i < 3) return
          if (i % 2 !== 0) conditionalchain.logic = x
          if (i % 2 === 0) {
            conditionalchain.val = x
            conditioncheck(conditionalchain.logic, conditionalchain.val)
          }
        })
        return bool ? fun(0) : (console.log('%c ERROR | Conditions not met.', 'color: red', runfn.name, payload, conditionalarray), f)
      })
      return resp
    } else return fun(0);

  },
  async schedule(state, payload) {
    let commands = {
      set: async () => {
        let hash = await store.dispatch('util', { type: 'hash', body: payload }).then(d => d)
        return fbBaseState.doc('events').get().then(async d => {
          let thistime = +payload.time || +Date.now()
          if (d.exists) {
            let data = d.data()
            if (!data[(+thistime - +d.data()['base'])]) {
              return fbBaseState.doc('events').update({ [(+thistime - +d.data()['base'])]: hash }).then(() => store.dispatch('t', { hash, payload }));
            } else {
              payload.time = thistime + 1
              return store.dispatch('schedule', payload)
            }
          } else {
            let now = Date.now()
            return fbBaseState.doc('events').set({ base: now }).then(() => fbBaseState.doc('events').set({ [payload.time ? payload.time - now : '0']: hash }, { merge: t })).then(() => store.dispatch('t', { hash, payload }));
          }
        })
      },
      check: () => {
        console.log('check');
      },
      remove: () => {
        console.log('remove');
      },
      update: () => {
        console.log('update');
      },
    }
    return commands[payload.command]()
    // schedule function to be used throughout the ecosystem for time-sensitive activity,
    // including auctions, deliveries, and other events. (sync time with GMT atomic clock via cloud fn)
    // If the current time is within the range of the scheduled function, it will be executed.
    // payload: ['type', 'database id', 'itemid', 'function']
    // types: ['set', 'check', 'remove', 'update']
    /*
      *** db schedule example ***
      "www.xmbl.io" : {
        "itemid-2341325": {
          1093534523: {function config object} or "function name string"
        }
      }
    */
  },
  async secrets(state, payload) {
    if (payload.type === 'share') {
      let hex = await ut.crypto('secret').then(d => d['str2hex'](payload.str))
      return await ut.crypto('secret').then(d => {
        return d['share'](hex, +payload.shares, +payload.thresh)
      })
    }
    if (payload.type === 'combine') {
      return await ut.crypto('secret').then(d => {
        return d['hex2str'](d['combine'](payload.shares))
      })
    }
  },
  set(state, payload) {
    return store.commit('set', payload)
  },
  async getlocalstate() {
    if (!localStorage.getItem('state') || !localStorage.getItem('statehash')) return
    if (await act.util(st, { type: 'hash', body: localStorage.getItem('state') }).then(h => h) == localStorage.getItem('statehash')) {
      return Object.entries(JSON.parse(localStorage.getItem('state'))).map(x => mu.set(st, { keys: [x[0]], val: x[1] })), t
    } else {
      return console.error(`
          local state length: ${localStorage.getItem('state').length}
          local hash: ${localStorage.getItem('statehash')}
          actual hash: ${await act.util(st, { type: 'hash', body: localStorage.getItem('state') }).then(h => h)}
          hash match: ${await act.util(st, { type: 'hash', body: localStorage.getItem('state') }).then(h => h) == localStorage.getItem('statehash')}
        `), f
    }
  },
  async setlocalstate() {
    let statestring = JSON.stringify(store.state)
    let statehash = store.dispatch('util', { type: 'hash', body: statestring })
    localStorage.removeItem('state')
    localStorage.removeItem('statehash')
    localStorage.setItem('state', statestring)
    localStorage.setItem('statehash', await statehash.then(h => h))
  },
  async token(state, payload) {
    const bitcoin = require('bitcoinjs-lib')
    const bip39 = require('bip39')
    const TESTNET = bitcoin.networks.testnet
    if (payload.type == 'nm') {
      return bip39.entropyToMnemonic(payload.pk)
    }
    if (payload.type === 'log') {
      let nm = bip39.generateMnemonic()
      let hex = bip39.mnemonicToSeedSync(nm).toString('hex')
      const mnemonic = bip39.entropyToMnemonic('b4579775af064467c5ddb71fa2a345ed')
      console.log(mnemonic);
      let identity = {
        nm: nm,
        hex,
        buffer: bip39.mnemonicToSeedSync(nm),
        validate: {
          valid: bip39.validateMnemonic(nm),
          nmtoentropy: bip39.mnemonicToEntropy(nm)
        },
        generators: {
          nm: bip39.generateMnemonic.toString(),
          seed: bip39.mnemonicToSeedSync.toString()
        }
      }
      return console.log('hello token', identity), identity
    }
    if (payload.type === 'check') {
      const Insight = require('bitcore-insight').Insight
      let insight = new Insight('testnet');
      return insight.getUtxos(prompt('What address should we check?'), (err, utxos) => {
        if (err) return err
        console.log(utxos)
      })
    }
    if (payload.type === 'nmtokey') {
      let nmtokey = bip39.mnemonicToSeedSync('table pave boy barrel mass treat glow imitate remember proof truck powder').toString('hex')
      let nmtoentropy = bip39.mnemonicToEntropy('table pave boy barrel mass treat glow imitate remember proof truck powder')
      let seedphrase = bip39.entropyToMnemonic(nmtoentropy)
      console.log(nmtokey, nmtoentropy, seedphrase);
      return nmtokey
    }
    if (payload.type === 'createUser') {
      const TESTNET = bitcoin.networks.testnet
      const keyPair = bitcoin.ECPair.makeRandom({ network: TESTNET })
      const { address } = bitcoin.payments.p2pkh({ pubkey: keyPair.publicKey, network: TESTNET })
      alert(JSON.stringify({ public: keyPair.__D.toString('hex'), private: keyPair.__Q.toString('hex'), address }, null, 2))
      let user = { public: keyPair.__D.toString('hex'), private: keyPair.__Q.toString('hex'), address, keyPair }
      user.nmonic = bip39.entropyToMnemonic(keyPair.__Q.toString('hex'))
      return user
    }
    if (payload.type === 'createTx') {
      const bitcore = require('bitcore-lib')
      const Insight = require('bitcore-insight').Insight
      let insight = new Insight('testnet')
      // let buff = '2e 98 b2 40 0e 76 2d e4 4e 33 4c f5 74 b1 ac 83 9e cf b9 52 0f cb 7c d8 f1 79 e9 46 ef 99 a3 d9'
      // let user = (async (exist) => {
      //   if (exist) return payload.txCreate.from
      //   else {
      //     const TESTNET = bitcoin.networks.testnet
      //     const keyPair = bitcoin.ECPair.makeRandom({ network: TESTNET })
      //     const { address } = await bitcoin.payments.p2pkh({ pubkey: await keyPair.publicKey, network: TESTNET  })(confirm('Use existing address?'))
      //     alert(JSON.stringify({address, keyPair}))
      //     return {address, keyPair}
      //   }
      // })(confirm('use existing address?'))
      insight.getUtxos(payload.tx.from, (err, utxos) => {
        if (err) console.error(err)
        console.info(utxos, payload)
        var privateKey = new bitcore.PrivateKey(payload.tx.sign, TESTNET)

        let tx = bitcore.Transaction()
        tx.from(utxos)
        tx.to(payload.tx.to, Number(payload.tx.amount))
        tx.change(payload.tx.from)
        tx.fee(Number(payload.tx.fee))
        tx.sign('help', privateKey, 'true')
        // tx.sign(buff.replace(/\s+/g, ''))
        tx.serialize()
        alert(tx.toString(), payload.tx.toString())
        insight.broadcast(tx.toString(), async (error, txid) => {
          if (await error) return error
          else console.log(await txid)
        })
      })
    }
  },
  async hashtable(state, payload) {
    // payload = {contract, type}
    console.log('hashtable', payload);
    // payload.contract is the hashable object {type,args,body,test}
    if (payload.contract) {
      const F = (args, body) => Function(...args, body)
      const sm = payload.contract.test && F(payload.contract.args, payload.contract.body)
      sm && sm()
    }
    let thash = '' // type hash 
    let nonce = 0
    let objsort = (obj) => Object.fromEntries(Object.entries(obj).sort()) // Object sort utility function
    // TODO change sorting function to accept lowercase and other normalizations
    return store.dispatch('util', { body: payload, type: 'hash' }).then(async (hash) => {
      console.log('hash', hash);
      payload.hash = hash
      async function micromining(hash) {
        return store.dispatch('util', { body: hash + nonce, type: 'hash' }).then(ret => {
          return ret.indexOf(payload.type) !== 0 ? (nonce++, micromining(hash)) : ret
        })
      }
      thash = await micromining(hash, nonce).then(ret => ret)
      payload.nonce = nonce // set winning nonce
      payload.thash = (!payload.contract || !payload.contract.test || eval(payload.contract.test[0])() == payload.contract.test[1]) && thash // run test and set valid thash
      console.log('found nonce:', nonce, payload, payload.contract && payload.contract.test && ('\nrunning test:', eval(payload.contract.test[0])() == payload.contract.test[1]), '\n\n\n\n')
      store.state.lexicon[payload.type] = store.state.lexicon[payload.type] || []
      store.state.lexicon[payload.type].push(payload.thash)
      store.state.hashtable[payload.thash] = payload
      store.state.hashtable = objsort(store.state.hashtable)
      store.state.app.advanced.hashtable = store.state.hashtable
      store.state.app.advanced.lexicon = store.state.lexicon
      store.dispatch('update', { type: 'app', data: store.state.app })
      return [hash, thash]
    })
  },
  transact(state, payload) {
    if (store.state.debug) mu.log('transact()', payload)
    if (!store.state.auth.uid) {
      store.state.show.auth = t
      return mu.log('Must be logged in', 'Please authenticate.')
    }
    var approved = f
    if (payload.type === 'hashtable') {
      // payload.contract is the hashable object {type,args,body,test}
      let F = (args, body) => Function(...args, body)
      console.log(F);
      let thash = '' // type hash 
      let nonce = 0
      return store.dispatch('util', { body: payload.contract, type: 'hash' }).then(async (hash) => {
        payload.contract.hash = hash
        async function micromining(hash) {
          return store.dispatch('util', { body: hash + nonce, type: 'hash' }).then(ret => {
            return ret.indexOf(payload.contract.type) !== 0 ? (nonce++, micromining(hash)) : ret
          })
        }
        thash = await micromining(hash, nonce).then(ret => ret)
        payload.contract.nonce = nonce // set winning nonce
        payload.contract.thash = eval(payload.contract.test[0])() == payload.contract.test[1] && thash // run test and set valid thash
        console.log('found nonce:', nonce, payload.contract, '\nrunning test:', eval(payload.contract.test[0])() == payload.contract.test[1], '\n\n\n\n')
        store.state.lexicon[payload.contract.type] = store.state.lexicon[payload.contract.type] || []
        store.state.lexicon[payload.contract.type].push(payload.contract.thash)
        store.state.hashtable[payload.contract.thash] = payload.contract
        // store.state.hashtable = objsort(store.state.hashtable)
        console.log(JSON.stringify(store.state.hashtable, null, 3));
        store.state.app.advanced.hashtable = store.state.hashtable
        store.state.app.advanced.lexicon = store.state.lexicon
        store.dispatch('update', { type: 'app', data: store.state.app })
        return hash
      })
    }
    else if (payload.payment['payment-type'] === 'PayPal') {
      approved = 'paypal'
      act.update(state, {
        type: 'orders',
        id: payload.orderId,
        data: {
          paid: 'paypal'
        }
      })
      return 'PayPal needs help'
    } else if (payload.payment['payment-type'] === 'Credit') {
      return axios({
        method: 'get',
        url: 'https://us-central1-p3c-prsprty.cloudfunctions.net/keys'
      }).then((retKeys) => {
        const cardInfo = {
          number: payload.payment.number.toString(),
          exp_month: payload.payment.month.length === 1 ? '0' + payload.payment.month : payload.payment.month,
          exp_year: '20' + payload.payment.year,
          cvc: payload.payment.cvc.toString()
        }
        var encryptedPackage = QuickEncrypt.encrypt(JSON.stringify(cardInfo), retKeys.data)
        mu.log('\ntransaction:\n', payload.orderId)
        return axios.post('https://us-central1-p3c-prsprty.cloudfunctions.net/charge', {
          token: encryptedPackage,
          pubKey: retKeys.data,
          amount: Number(payload.fullOrder.total) * 100,
          currency: 'usd',
          description: payload.fullOrder.id
        }).then((retCharge) => {
          approved = retCharge.data.status === 'succeeded' ? t : f
          if (approved) {
            act.update(state, {
              type: 'orders',
              id: payload.orderId,
              data: {
                paid: 'credit card'
              }
            })
          }
          mu.log('charge went through', retCharge.data)
          act.notify('billing', 'Transaction ' + (retCharge.data.message || retCharge.data.status), [store.state.auth.uid], 'Stripe', `/orders/${payload.orderId}`, payload.orderId)
          return retCharge
        })
      })
    } else if (payload.payment['payment-type'] === 'Crypto') {
      let cbObj = {
        'name': store.state.auth.uid,
        'description': payload.orderId,
        'pricing_type': 'fixed_price',
        'local_price': {
          'amount': payload.fullOrder.total,
          'currency': 'USD'
        },
        'metadata': {
          app: store.state.app.basics.database,
          buyer: store.state.auth.uid,
          currency: payload.payment.currency,
          order: payload.orderId,
          version: 'v' + version
        },
        'requested_info': ['name', 'email']
      }
      return axios.post('https://us-central1-p3c-prsprty.cloudfunctions.net/coinbase', cbObj).then(ret => ret)
    } else if (payload.payment['payment-type'] === 'xmbl') {
      approved = 'xmbl'
      act.update(state, {
        type: 'orders',
        id: payload.orderId,
        data: {
          paid: approved
        }
      })
      return t
    } else {
      if (approved) {
        act.update(state, {
          type: 'orders',
          id: payload.orderId,
          data: {
            paid: approved
          }
        })
      }
    }
    return payload = null

  },
  async t(state, payload) {
    let batch = fb.firestore().batch()
    // TODO deep sort, normalize, and minimize token
    console.log('tokenizing', JSON.stringify(payload, null, 4));
    if (payload.gettoken) {
      console.log(fbBaseTokens.doc('data').get().then(d => d));
      return await fbBaseTokens.doc('data').get().then(d => {
        console.log(d.data());
        store.commit('set', { key: 'tokens', val: d.data() })
        return d
      })

    }
    return store.dispatch('hashtable', payload).then(h => {
      console.log('hashtable return hashes', h);
      batch
        .set(fbBaseTokens.doc('hashtable'), { [h[1]]: h[0] }, { merge: t })
        .set(fbBaseTokens.doc('data'), { [h[1]]: payload }, { merge: t })
      if (payload.payload && payload.payload.oid) {
        batch.set(fbBaseTokens.doc('mutate'), { [payload.payload.oid]: fb.firestore.FieldValue.arrayUnion(h[1]) }, { merge: t })
      }
      batch.commit()
      return h
    })
  },
  async util(state, payload) {
    payload = payload.type ? payload : payload[0]
    const pure = {
      decodewm() {
        // payload = {url}
        return ut.decodewm(payload.url, payload.id)
      },
      cbor2str() {
        let ab = hex2ab(payload.cbor.toString())
        return cbor.decode(ab)
      },
      hex2str() {
        var hex = payload.hex.toString();
        var str = '';
        for (var n = 0; n < hex.length; n += 2) {
          str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
        }
        // console.log({str})
        return str;
      },
      order() {
        // console.log({ payload });
        // payload = {data, prop, direction}
        let orderarr
        if (!Array.isArray(payload.data)) {
          const orderentries = Object.entries(payload.data)
          orderarr = orderentries.map(x => {
            let item = { ...x[1], _key: x[0] }
            return item
          })

        } else {
          orderarr = payload.data
        }
        // console.log({ orderarr });
        const sorted = _.orderBy(orderarr, [x => x[payload.prop].toLowerCase()], payload.direction || 'asc')
        // console.log({ sorted });
        return sorted
      },
      right() {
        // payload = {item, fn, args}
        return Array.isArray(payload.args) ? payload.item[payload.fn](...payload.args) : payload.item[payload.fn](payload.args)
      },
      filter() {
        // payload = {iter, fn}
        return payload.iter.filter(i => [payload.fn](i))
      },

      if() {
        // payload = {comparitor, conditions[0,1]}
        switch (payload.comparitor) {
          case '=': return (payload.conditions[0] === payload.conditions[1]);
          case '!=': return (payload.conditions[0] !== payload.conditions[1]);
          case '<': return (payload.conditions[0] < payload.conditions[1]);
          case '<=': return (payload.conditions[0] <= payload.conditions[1]);
          case '>': return (payload.conditions[0] > payload.conditions[1]);
          case '>=': return (payload.conditions[0] >= payload.conditions[1]);
          case '': return (payload.conditions[0] ? t : f);
          default:
            return f
        }
      },
      help() {
        return {
          right: { item: Object, fn: String, args: Array },
          filter: { iter: Array, fn: Function },
          if: { comparitor: String, conditions: Array },
          map: { iter: Array, fn: Function },
          set: { obj: Object, prop: String, val: Object },
          delete: { obj: Object, prop: String },
        }
      },
      async map() {
        // payload = {iter, fn}
        let entries = f // setup for object iteration, defaults to f
        // if pl has fn setup store.dispatch as fn, else create a new Function with body and args
        // TODO allow multiple inputs
        let fn = payload.fn.fun && payload.fn.fun.commands ? store.dispatch : typeof payload.fn !== 'function' ? new Function('x', payload.fn + '(x)') : payload.fn

        // if iter is an object, get array of entries
        if (!Array.isArray(payload.iter) && typeof payload.iter == 'object') {
          entries = t
          payload.iter = Object.entries(payload.iter)
        }
        // map over iter

        let m = payload.iter.map(async (i) => {
          let item = entries ? i[1] : i
          let x;

          if (payload.fn.fun && payload.fn.fun.commands) {
            // setup inputs for fn args
            let inputs = {}
            Object.entries(payload.fn.fun.inputs).map(q => {
              return inputs[q[0]] = item
            })
            payload.fn.payload = inputs
            x = fn('run', payload.fn)
            return await x || i
          } else {
            x = fn(item)
            return x || i
          }
        })
        if (payload.fn.fun && payload.fn.fun.commands) {
          return Promise.all(m).then(v => {
            let ret = entries ? Object.fromEntries(v) : v
            return ret
          })
        } else {
          let ret = entries ? Object.fromEntries(m) : m
          return ret
        }
        // TODO finish mapping with custom functions by getting value of promises in m


        // return payload.iter.map(i => fn(i))
      },
      set() {
        // payload = {obj, prop, val}
        Vue.set(payload.obj, payload.prop, payload.val)
        return payload.obj[payload.prop]
      },
      delete() {
        // payload = {obj, prop}
        Vue.delete(payload.obj, payload.prop)
        return payload.obj[payload.prop]
      },
      hash() {
        // TODO deep sort, normalization, and compression
        // payload {body, count}
        let hex;
        payload.count = !payload.count && 1 || payload.count
        let objsort = (obj) => Object.fromEntries(Object.entries(obj).sort())
        for (let x = 0; x < payload.count; x++) {
          hex = new Hashes.SHA256().hex((typeof hex === 'string' && hex.length > 0) ? hex : typeof payload.body === 'object' ? JSON.stringify(objsort(payload.body)) : payload.body)
        }
        return hex
      },
      encode() { // todo finish encode and decode conversions for b64, hex, arraybuf, and binary
        const encodetypes = {
          base64url: x => '~' + base64url(x),
          // hex: x=> '.' + 
        }
        encodetypes['base64url', payload]
      },
      decode() {

      },
      normalize() {
        return payload.str.replaceAll(' ', '_').replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase()
      },
      qr() {
        return ut.qr(payload.obj)
      }
      // decode(){}
    }
    return pure[payload.type]()
  },
  async update(state, payload) {
    if (!store.state.auth.uid) {
      store.state.show.auth = t
      return console.log('Must be logged in', 'Please authenticate.')
    }
    console.log('update', payload)
    payload.id = payload.type === 'user' ? payload.id || payload.uid || payload.mId || payload.fId || payload.data.id : payload.id || store.state.auth.uid
    if (payload.type === 'app') {
      !payload.data.user ? payload.data.user = [store.state.auth.uid] : void 0;
      return fbBase.set({ app: payload.data }).then((x) => {
        payload.reload ? window.location.reload() : store.commit('set', { keys: ['show', 'reinit'], val: t })
        store.commit('set', { key: 'app', val: payload.data })
        return x
      })
    } else if (payload.type === 'orders') {
      return fbBase.collection('orders').doc(payload.id).get().then((orderData) => {
        var order = orderData.data()
        var completeCheck = []
        var sellers = []
        if (payload.data.item) {
          if (sellers.indexOf(payload.data.item.seller) < 0) {
            sellers.push(payload.data.item.seller)
          }
          order.items.forEach((item, itemKey) => {
            if (JSON.stringify(item).indexOf(payload.data.item.iitemid) > -1 && JSON.stringify(item).indexOf(store.state.auth.uid) > -1) {
              order.items[itemKey] = payload.data.item
              if (order.items[itemKey].status !== 'delivered') {
                completeCheck.push(item.status)
              }
              order.complete = completeCheck.length === 0
              fbBase.collection('orders').doc(payload.id).update(order).then(() => {
                act.notify('order', `${order.items[itemKey].itemTitle} ${order.items[itemKey].status}`, [item.buyer], store.state.auth.uid, `/orders/${payload.id}`, payload.id)
              })
            }
          })
        }
        if (payload.data.paid) {
          // todo create batch transaction instead of so many updates
          order.paid = payload.data.paid
          Vue.set(store.state.user[store.state.auth.uid].auctions, order.items[0].type + '_' + order.items[0].iitemid, order.id)
          store.dispatch('update', { type: 'user', id: store.state.auth.uid, data: store.state.user[store.state.auth.uid] })
          fbBase.collection('orders').doc(payload.id).update(order).then(async () => {
            let item = store.state.items[order.items[0].type][order.items[0].id] || await store.dispatch('query', { type: 'item', collection: order.items[0].type, id: order.items[0].iitemid }).then(i => i)
            item.purchases.auction ? item.purchases['auction complete'] = order.id : null
            store.dispatch('update', { type: item.type, id: item.id, data: item })
            sellers.forEach((seller) => {
              act.notify('sale', `Order ${order.id} paid`, [seller], 'transaction', `/sales/${payload.id}`, payload.id)
            })
          })
        }
        if (payload.data.crypto) {
          order.payment = payload.data.crypto
          fbBase.collection('orders').doc(payload.id).update(order).then(() => {
            mu.setState(store.state, { prop: 'orders', prop2: payload.id, val: order })
          })
        }
        return orderData.data()
      })
    } else if (payload.type === 'msgs') {
      let dateid = Date.now();
      var msgRef = fbBase.collection(payload.type).doc(payload.mId)
      return msgRef.get().then(async (msgData) => {
        var msg = msgData.data()
        if (payload.topic && payload.topic !== msg.topic) {
          msg.topic = payload.topic
          return msgRef.update(msg)
        }
        msg.banter[dateid] = { text: payload.text, user: st.auth.uid }
        msg.users.forEach((user) => {
          if (user === store.state.auth.uid) {
            fbBase.collection('user').doc(user).update({
              [`msgs.${payload.mId}`]: 'unseen'
            })
          } else {
            fbBase.collection('user').doc(user).update({
              [`msgs.${payload.mId}`]: t
            })
          }

        })

        return msgRef.update(msg).then(() => {
          return dateid
        })
      })
    } else if (payload.type === 'notifications') {
      var notifyRef = fbBase.collection(payload.type).doc(payload.id)
      payload.data.actions = payload.data.actions || []
      notifyRef.update(payload.data)
      Vue.set(st.notifications[payload.id], payload.data)
    } else if (payload.type === 'user') {
      // mu.log('user update, no reload', payload.data)
      payload.id = payload.id || store.state.auth.uid
      payload.data.timestamps = payload.data.timestamps || []
      payload.data.timestamps.push(Date.now())
      var userUpdateRef = fbBase.collection(payload.type).doc(payload.id)
      var userPrivateUpdateRef = fbBase.collection(payload.type).doc(payload.id).collection('private').doc('content')
      payload.data = Object.fromEntries(Object.entries(payload.data).filter(x => x[1]))
      userPrivateUpdateRef.set(payload.data)
      userUpdateRef.update(payload.data)

      if (payload.data.basics && (payload.data.basics.name !== store.state.auth.name)) {
        var username = fb.auth().currentuser;
        username && username.updateProfile({
          displayName: payload.data.basics.name
        })
      }

      if (payload.data.basics && (store.state.auth.email !== payload.data.basics.email)) {
        var userEm = fb.auth().currentuser;
        userEm && userEm.updateEmail(payload.data.basics.email)
      }

      return userUpdateRef.get().then((data) => {
        if (!data.exists) { return console.error('no data', data) }
        return (async () => {
          var user = data.data()
          payload.data.basics && Object.keys(payload.data.basics).forEach((key) => {
            if (!payload.data.basics[key] || (payload.type === 'user' && key === 'user')) {
              delete payload.data.basics[key]
            } else {
              user[key] = payload.data.basics[key]
            }
          })
          mu.setState(store.state, {
            prop: store.state.auth.uid === payload.id ? 'user' : 'users',
            prop2: payload.id,
            val: user
          })
          mu.setState(store.state, {
            prop: 'users',
            prop2: payload.id,
            val: user
          })
          mu.setState(store.state, { prop: 'userlist', val: store.state.users })
          // await userUpdateRef.update(user)
          store.dispatch('indexer', [user, payload.id, 'user'])
          return user
        })()
      })
    } else if (payload.type === 'comments') {
      var commentRef = fbBase.collection(payload.type).doc(payload['commentsid'])
      commentRef.update(payload.id, payload).then(() => {
        Vue.set(st.componentKeys, 'comments', st.componentKeys.comments + 1)
        Vue.set(st.comments[payload['commentsid']][payload.id], {})
        Vue.set(st.comments[payload['commentsid']][payload.id], payload)
      })
    } else if (payload.type === 'keys') {
      console.log('updating keys', payload)
      return fbusersbase.collection(store.state.auth.uid).doc('keys').set(payload.keys)
    }
    else if (payload.type === 'files') {
      console.log('updating file', payload)
      return fbusersbase.collection(store.state.auth.uid).doc('files').set({ [payload.hash]: payload.data }, { merge: t })
    } else {
      console.log('general update', payload)
      const date = Date.now()
      // Clean up timestamps
      if (payload.data.timestamps) {
        payload.data.created = payload.data.timestamps[0]
        delete payload.data.timestamps
      }
      const olditem = await fbBase.collection(payload.type).doc(payload.id).get().then(i => i.data())
      console.log({ olditem });
      delete olditem.timestamps
      payload.data.history = payload.data.history || {}
      const dif = JSON.parse(JSON.stringify(diff(olditem, payload.data)))
      dif && Vue.set(payload.data.history, date, dif)
      payload.data.edited = date;
      Object.keys(payload.data).forEach((key) => {
        if (!payload.data[key] || (payload.type === 'user' && key === 'user')) delete payload.data[key]
      })
      console.log('prepping indexer', { payload, olditem });
      return store.dispatch('indexer', [payload.data, payload.id, payload.type, olditem]).then(() => {
        return fbBase.collection(payload.type).doc(payload.id).set(payload.data, { merge: t }).then(() => {
          if (payload.type !== 'user' && payload.type !== 'app' && payload.type !== 'orders' && payload.type !== 'sales') {
            return act.query(state, { type: 'item', collection: payload.type, id: payload.id })
          }
        })
      }).then(async () => {
        let data = dif, oid = payload.id
        dif && store.dispatch('t', { type: store.state.lexicon.create.update, payload: { data, oid, date } })
      })
    }
  },
  upload(state, payload) {
    let time = Date.now(), hash;
    store.commit('point', { header: 'Uploading file', text: 'Authenticating and checking tokenisation', sticky: t, time })

    if (!store.state.auth.uid) {
      store.state.show.auth = t
      return mu.log('Must be logged in', 'Please authenticate, mfkr.')
    }

    if (store.state.debug) mu.log('upload()', payload)

    var storageRef = storage.ref()
    var reader = new FileReader();

    reader.onload = async function (event) {

      var data = event.target.result; // the file
      hash = await store.dispatch('worker', data).then(h => h)
      const name = encodeURIComponent(payload.files[0].name.norm())

      // make firebase ref obj
      var fileRef = storageRef.child(store.state.auth.uid).child(hash).child(name)

      store.commit('point', { header: 'Uploading file', text: 'Connecting to file host', sticky: t, time })

      // put file to firebase
      return fileRef.put(payload.files[0]).then(async function (snapshot) {

        let file = snapshot.metadata;
        await snapshot.ref.getDownloadURL().then(url => {

          // set-up file object
          let fileobj = {
            [hash]: {
              url: [url],
              type: file.contentType,
              name: file.name,
              size: file.size,
              hash
            }
          }

          // tokenize file
          store
            .dispatch('t', {
              type: store.state.lexicon.create.file,
              payload: fileobj[hash],
            })
            .then(async (h) => {
              file.token = h;

              store.dispatch('update', {
                type: 'files',
                hash,
                data: { ...fileobj[hash], token: file.token, }
              });

              // set fileobj to user's collection
              fbusersbase.collection(store.state.auth.uid).doc('files').set(fileobj, { merge: t })

              store.state.lastuploadurls.push(url)
              store.state.lastuploadhash.push(hash)

              store.commit('set', { keys: ['lastuploadurls'], val: store.state.lastuploadurls })
              store.commit('set', { keys: ['lastuploadhash'], val: store.state.lastuploadhash })

              store.commit('point', { header: 'Upload Complete', text: 'Your file is now available', link: url, speed: 5000 })

              console.log(await store.dispatch('ipfs', payload.files[0]).then(h => h))
              return await store.dispatch('query', { id: store.state.uid, type: 'user' }).then(() => snapshot)
            })

        })
      })
    };

    return reader.readAsBinaryString(payload.files[0]);


  },
  validjson(state, str) {
    try {
      if (+str + +str == +str * 2) return f;
      JSON.parse(str);
      return t;
    } catch (e) {
      return f;
    }
  },
  worker(state, str) {
    return (
      async () => {
        const worker = new Worker("worker.js");
        // WebWorkers use `postMessage` and therefore work with Comlink.
        const obj = Comlink.wrap(worker);
        // console.log(str, 'obj.hashes', await obj.hashes(str).then(x => x));
        // alert(`Counter: ${obj.counter}`);
        return await obj.hashes(str)
      })()

  },
}
export const store = new vuex.Store({
  state: st,
  mutations: mu,
  actions: act
})
const s = store.state, d = store.dispatch, m = store.commit
const mp = (a, b, c) => m('point', { header: a, text: b, sticky: c })
